import { catchError } from 'rxjs/operators';
import { GelAllCasesRequestModel } from './../../../../../cases-v2/models/cases.model';
import { UtilityService } from './../../../../../inventory/sales-order/utils/utility.service';
import { LocationsService } from './../../../../../inventory/locations/locations.service';
import { ObjectNames as InventoryObjectNames } from '../../../../../inventory/constants/constants';
import { GelAllAccountRequestModel } from './../../../../../accounts-v2/models/account-request.model';
import { OpportunitiesService } from '../../../../../opportunities-v2/services/opportunity.service';
import { TerriService } from './../../../../../more/territory/services/terriService';
import { AccountServiceN } from './../../../../../accounts-v2/services/account.services';
import { LeadServiceN } from './../../../../../leads-v2/services/lead.service';
import { SavedSearchRulesDataService } from './../saved-search-rules-data.service';
import { SharedTemplateService } from './../../../services/template.service';
import { AccountModuleId, ContactModuleId, LeadModuleId, TaskModuleId, TerritoryModuleId, OpportunityModuleId, ActivityModuleId, ProductModuleId, EstimateOrderModuleId, InvoiceOrderModuleId, SOModuleId, VendorModuleId, LocationModuleId, CaseModuleId, PurchaseOrderModuleId, BillPaymentModuleId, VendorReturnModuleId } from './../../../constants/modules.constant';
import { ShippingmethodService } from './../../../../../configurations/inventory/setup/shippingmethod/shippingmethod.service';
import { ShippingtermService } from './../../../../../configurations/inventory/setup/shippingterm/shippingterm.service';
import { PaymentmethodService } from './../../../../../configurations/inventory/setup/paymentmethod/paymentmethod.service';
import { PaymenttermService } from './../../../../../configurations/inventory/setup/paymentterm/paymentterm.service';
import { ProductsService } from './../../../../../inventory/products/products.service';
import { ContactService } from './../../../../../contacts/contactService';
import { CrmAccountFieldService } from './../../../../../configurations/crm/account/fields/fields.service';
import { AccountService } from './../../../../../accounts/accountService';
import { SavedSearchesService } from './../../../../../misc/saved-searches/services/saved-searches.service';
import { AppMainComponent } from './../../../../../app.main.component';
import { ConfigurationService } from './../../../../../configurations/configurationService';
import { AppMainService } from './../../../../../app-main.service';
import { UserService } from './../../../../../service/userservice';
import { AgingStatus, BillPaymentStatus, BillStatus, DateTimeOperatorValue, EstimateNewStatusObjects, InvoicePaymentStatusEnumObjects, OrderStatusObjects, ProductTransactionAction, ProductTransactionStatus, PurchaseOrderIsActive, PurchaseOrderStatus, RatingValueObjects, SalesOrderStageEnumObjects, SalesOrderStatusEnumObjects, SavedSearchActiveInActiveStatus, SavedSearchOpportunityActiveInActiveStatus, SavedSearchParentModule, ShipmentStatusObjects, TaxPreferenceObjects, TransactionTypes, VendorAllBillStatus, VendorBillPaymentStatus, VendorCreditStatus, VendorPaymentReceiptsStatus, VendorRMAStatus, VendorTransactionStage, VendorTransactionTypes } from './../../../../../misc/saved-searches/models/saved-search.static';
import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { SavedSearchNS } from 'src/app/misc/saved-searches/models/saved-search.models';
import { DataTypeWithOperatorNS } from 'src/app/misc/saved-searches/models/saved-search.static';
import { CUSTOMFIELD_TYPE_IDS } from '../../../constants/typeId';
import { Subject, forkJoin, of, takeUntil } from 'rxjs';
import { AppRuleSelectionService } from '../../rule-selection/app.rule.selection.service';
import { LocalDatePipe } from '../../../pipes/local-date.pipe';
import { LeadService } from 'src/app/leads/leadService';
import { AccountGroupId } from 'src/app/accounts/account.enum';
import { MultiSelectFieldsNS } from 'src/app/misc/saved-searches/models/saved-search-multiselect-fields.static';
import { ParseHelper } from '../../../parse.helper';
import { StatusGroupIds, TypeGroupIds } from '../../../constants/category-groupid.constants';
import { MessageService } from 'primeng/api';
import { Status } from 'src/app/models/statusEnums';
import { GelAllOpportunityRequestModel } from '../../../../../opportunities-v2/model/opportunities.model';
import * as _ from "lodash";
import { SharedChannelService } from '../../../services/channel.service';
import { LogService } from '../../shared-logs/log-service.service';
import { GetAllLeadRequestModel } from '../../../../../leads-v2/model/lead-request.model';
import { setSavedSearchValueDateType } from 'src/app/misc/saved-searches/helpers/prepare-saved-searh-filter.helper';
import { SalesOrderService } from '../../../../../inventory/sales-order/sales-order.service';
import { TaskCategoryService } from 'src/app/shared/api/api';
import { SharedTaskService } from 'src/app/shared/shared-task/shared-task.service';
import { TaskStatus } from '../../../model/taskStatus';
import { TasksService } from 'src/app/profile/tasks';
import { SavedSearchTask } from '../../../enums/task.enum';
import { CasesService } from 'src/app/cases-v2/services/cases.service';
import { PurchasesService } from 'src/app/inventory/purchases/purchases.service';
export interface LastRuleValues {
    selectedFilter: SavedSearchNS.IField,
    selectedOperator: SavedSearchNS.IOperator,
    selectedValue: any;
    selectedValue2: any;
    selectedChoice: SavedSearchNS.IChoice;
    selectedDataTypeWithOperator: DataTypeWithOperatorNS.ISavedSearchDataTypeWithOperator;
    allEnumMultiselect: any[];
    treeSelectData: any[];
    selectedGroupLabel: any;
    selectedGroupChildren: any;
    selectedGroup: boolean;
    filtersDD: SavedSearchNS.IField[],
    filtersDDTree: any[],
    compareWithField: boolean;
    comparisonCriteria: string;
    customAttributeObjectId: number,
    comparisonCustomAttributeObjectId: number,
    comparisonCriteriaLabel: string;
    comparisonCriteriaParentLabel: string;
    isCustomComparisonCriteria: boolean;
    ruleErrorMsg?: string;
}

@Component({
  selector: 'app-saved-search-main-module-rules-selection',
  templateUrl: './saved-search-main-module-rules-selection.component.html',
  styleUrls: ['./saved-search-main-module-rules-selection.component.scss'],
  providers: [LocalDatePipe, LocationsService, SalesOrderService]
})
export class SavedSearchMainModuleRulesSelectionComponent implements OnInit, OnDestroy, OnChanges {
    protected ngUnsubscribe$: Subject<void> = new Subject<void>();

    @Output() availableFieldsLoaded = new EventEmitter<SavedSearchNS.IField[]>();

    //Input
    @Input() selectedParentModule: SavedSearchNS.IObjectType;
    @Input() selectedParentTemplate: SavedSearchNS.ITemplate;// Parent module Template
    @Input() selectedAccountChannel = null;
    @Input() selectedAssoModule: SavedSearchNS.IObjectType;
    @Input() selectedAssoTemplate: SavedSearchNS.ITemplate;
    @Input() isMainModule: boolean = true;
    @Input() ruleData: SavedSearchNS.IRuleList[] = [];
    @Input() ruleList: SavedSearchNS.IRuleList[] = [];
    @Input() lastRule: SavedSearchNS.IRuleList[] = [];
    @Input() displayRules: boolean = false;
    @Input() editRule: boolean = false;
    @Input() selectedRule: SavedSearchNS.IRuleList = null;

    //Component variables

    @Input() lastRuleValues: LastRuleValues = {
        selectedFilter: null,
        selectedOperator: null,
        selectedValue: null,
        selectedValue2: null,
        selectedChoice: { id: 1, name: "And" },
        selectedDataTypeWithOperator: null,
        allEnumMultiselect: [],
        treeSelectData: [],
        selectedGroupLabel: "",
        selectedGroupChildren: "",
        selectedGroup: true,
        filtersDD: [],
        filtersDDTree: [],
        compareWithField: false,
        comparisonCriteria: null,
        customAttributeObjectId: null,
        comparisonCustomAttributeObjectId: null,
        comparisonCriteriaLabel: null,
        comparisonCriteriaParentLabel: null,
        isCustomComparisonCriteria: false
    }
    availableCompareFields: any[] = [];
    filterTreeView: boolean = true;
    filterDDTree: any[] = [];
    filterDDFlat: any[] = [];
    selectedFieldErrorMsg: string = "";
    dateTimeOperatorValue = DateTimeOperatorValue;
    choicesDD: SavedSearchNS.IChoice[] = [
        { id: 1, name: "And" },
        { id: 2, name: "Or" },
    ];
    booleanValueDD: SavedSearchNS.BooleanValue[] = [
        { id: 1, name: "true" },
        { id: 2, name: "false" },
    ];
    selectedLatLng: SavedSearchNS.AddressLatLong = { address: null, latitude: null, longitude: null, radius: null };
    selectedLatLngType: 'Add' | 'List' | 'Edit';
    selectedEditRule: SavedSearchNS.IRuleList;

    displayAddressSelect = false;
    savedSearchTaskType:any[] = [
        { id: 1, name: "Single Task" },
        { id: 2, name: "Multiple Task" },
    ];
    //
    users = [];
    allCountryList = [];
    territory = [];
    activityModuleList: {id: number, name: string}[] = [
        {
            id: AccountModuleId,
            name: 'Account'
        },
        {
            id: LeadModuleId,
            name: 'Lead'
        },
        {
            id: OpportunityModuleId,
            name: 'Opportunity'
        },
    ];

    multiSelectFieldsNS = MultiSelectFieldsNS;
    taskCategories: any[] = [];
    length: number = 0;
    checkTemplateCalled:boolean=false


    constructor(
        private messageService: MessageService,
        public userService: UserService,
        private appMainService: AppMainService,
        private configService: ConfigurationService,
        public app: AppMainComponent,
        private ruleService: AppRuleSelectionService,
        private savedSearchesService: SavedSearchesService,
        public localDatePipe: LocalDatePipe,
        private leadService: LeadService,
        private leadServiceN: LeadServiceN,
        private accountService: AccountService,
        private accountServiceN: AccountServiceN,
        private fieldService: CrmAccountFieldService,
        private contactService: ContactService,
        private productsService: ProductsService,
        private paymenttermService: PaymenttermService,
        private paymentmethodService: PaymentmethodService,
        private shippingtermService: ShippingtermService,
        private shippingmethodService: ShippingmethodService,
        private sharedTemplateService: SharedTemplateService,
        private sharedChannelService: SharedChannelService,
        private savedSearchRulesDataService: SavedSearchRulesDataService,
        private terriservice: TerriService,
        private opportunityService: OpportunitiesService,
        private logService: LogService,
        private locationService: LocationsService,
        private salesOrderService: SalesOrderService,
        private utilityService: UtilityService,
        private taskCategoryService:  TaskCategoryService,
        private taskService: SharedTaskService,
        private tasksService: TasksService,
        private casesService: CasesService,
        private purchaseService: PurchasesService,
    ) {
        this.users = ParseHelper.DeepCopy(this.app.usersList);
     }

    ngOnInit(): void {
        this.savedSearchRulesDataService.getChoiceData().pipe(takeUntil(this.ngUnsubscribe$)).subscribe(data => {
            if (data) {
            //    this.changeAllChoiceConditionally(data);
            }
        });
    }

    ngOnChanges(changes: SimpleChanges): void {

        if(changes['ruleData'] && changes['ruleData']?.currentValue){
            this.users = this.app.usersList.filter(user=> user.statusId==Status.Active);
            this.ruleData = changes['ruleData']?.currentValue;
            this.selectedFieldErrorMsg = "";
            if(this.lastRuleValues.filtersDDTree?.length>0){
                this.setDependentTreeFields(null);
            }
        }else if(changes['displayRules'] && changes['displayRules']?.currentValue){
            this.displayRules = changes['displayRules']?.currentValue;
            this.users = this.app.usersList.filter(user=> user.statusId==Status.Active);
            if(this.lastRuleValues.filtersDDTree?.length>0){
                this.setDependentTreeFields(null);
            }
        }

        if(changes['selectedParentModule'] && changes['selectedParentModule']?.currentValue){
            this.selectedParentModule = changes['selectedParentModule']?.currentValue;
            this.checkTemplateCalled=false
        }

        if(changes['selectedParentTemplate'] && changes['selectedParentTemplate']?.currentValue){
            this.selectedParentTemplate = changes['selectedParentTemplate']?.currentValue;

            if(this.isMainModule && !this.editRule){
                this.getFieldListByTemplate(true, this.selectedParentTemplate, null);
            }
        }

        if(changes['selectedAssoTemplate'] && changes['selectedAssoTemplate']?.currentValue){
            this.selectedAssoTemplate = changes['selectedAssoTemplate']?.currentValue;
        }

        if(changes['selectedAssoModule'] && changes['selectedAssoModule']?.currentValue){
            this.selectedAssoModule = changes['selectedAssoModule']?.currentValue;

            if(!this.isMainModule && !this.editRule){
                this.getFieldListByTemplate(false, this.selectedAssoTemplate, null);
            }
        }

        if(changes['selectedRule'] && changes['selectedRule']?.currentValue){
            this.selectedRule = changes['selectedRule']?.currentValue;
            this.users = this.app.usersList.filter(user=> user.statusId==Status.Active);
            if(this.editRule){
                this.isMainModule = this.selectedRule.isMainModule;

                if(!this.isMainModule){
                    this.selectedAssoModule = ((this.selectedRule.subModule||this.selectedRule.module) as any) ??  this.selectedAssoModule;
                    this.selectedAssoTemplate = this.selectedRule.template ? this.selectedRule.template :  this.selectedAssoTemplate;
                }

                this.getFieldListByTemplate(this.selectedRule.isMainModule,this.selectedRule.template, this.selectedRule);
            }
        }

        if(changes['selectedAccountChannel'] && changes['selectedAccountChannel']?.currentValue){
            this.selectedAccountChannel = changes['selectedAccountChannel']?.currentValue;
            if(this.checkTemplateCalled == true && !this.ruleData.length){
                this.showDefaultParentRule();
                this.checkTemplateCalled = false;
            }
            // this.getFieldListByTemplate(true, this.selectedParentTemplate, null);
        }
    }

    ngOnDestroy(): void {
        if (this.ngUnsubscribe$) {
            this.ngUnsubscribe$.next();
            this.ngUnsubscribe$.complete();
            this.ngUnsubscribe$.unsubscribe();
        }
    }

    //Get Field list by template
    getFieldListByTemplate(isMainModule: boolean, template: SavedSearchNS.ITemplate, editedRule: SavedSearchNS.IRuleList) {
        const objectIds: number[] = [AccountModuleId,LeadModuleId,ContactModuleId,TaskModuleId,TerritoryModuleId,OpportunityModuleId,ActivityModuleId,VendorModuleId,LocationModuleId];
        this.filterDDTree = [];
        if(objectIds.includes(template?.objectId) || objectIds.includes(this.selectedParentModule?.objectId)){
            this.filterTreeView = true;
            this.appMainService.isShowSpinner('getFieldListByTemplate');
            this.sharedTemplateService.getTemplatesSectionsFieldsForSavedSearch(
                isMainModule ? template?.objectId : this.selectedParentModule?.objectId,
                isMainModule ? template?.objectId : this.selectedAssoModule?.objectId,
                isMainModule ? template?.id : this.selectedParentTemplate?.id).subscribe
                ({
                next: (response) => {
                    this.appMainService.isHideSpinner('getFieldListByTemplate');
                    this.prepareFieldObjectAndTreeForAccLead(response||[], editedRule);
                    this.checkTemplateCalled = true;
                    if (!this.ruleData.length) {
                        this.showDefaultParentRule();
                    }
                },
                error: (error) => {
                    this.appMainService.isHideSpinner('getFieldListByTemplate');
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: error?.error?.message ? error?.error?.message : 'Templates are not loaded, please try again...'
                    });
                }
              });
        }else{
            this.filterTreeView = false;
            this.appMainService.isShowSpinner('getFieldListByTemplate');
            // this.configService.getLeadTemplateDetails(data.id, isMainModule).pipe(takeUntil(this.ngUnsubscribe$)).subscribe((resp: SavedSearchNS.IField[]) => {
            this.configService.getTemplateDetails(isMainModule ? template?.objectId : this.selectedParentModule?.objectId,
                isMainModule ? template?.objectId : this.selectedAssoModule?.objectId,
                isMainModule ? template?.id : this.selectedParentTemplate?.id, isMainModule).pipe(takeUntil(this.ngUnsubscribe$)).subscribe((resp: SavedSearchNS.IField[]) => {
                this.appMainService.isHideSpinner('getFieldListByTemplate');
                //Prepar Field Object
                this.prepareFieldObject(resp, editedRule,template);
                if (!this.ruleData.length) {
                    this.showDefaultParentRule();
                }
            },
            error => {
                this.appMainService.isHideSpinner('getFieldListByTemplate');
            });
        }
    }

    prepareFieldObjectAndTreeForAccLead(data: any[], editedRule: SavedSearchNS.IRuleList) {
        const selectableFields: any[] = [];

        this.filterDDTree = data.map(item => {
            const fields = item.fields
              .filter(field => field.enableSavedSearchQuery === true)
              .map(field => {
                const childFields = field.childFields
                  .filter(childField => childField.enableSavedSearchQuery === true)
                  .map(childField => {
                    const custom = false;
                    const valueDataType = '';
                    //Set Value DataType for UI implementation
                    setSavedSearchValueDateType(childField)
                    childField.operatorsDD = childField?.operators?.length>0 ? childField.operators.map((o, i) => ({ id: i + 1, name: o })) : [];

                    const rField = {
                        label: childField.labelName,
                        labelname: childField?.labelName,
                        parentLabelName: field?.labelName||field?.name,
                        id: childField.id,
                        isSelectableField: true,
                        customAttributeObjectId: childField?.customAttributeObjectId||null,
                        custom,
                        valueDataType,
                        ...childField,
                        children: []
                    }

                    selectableFields.push({...rField,children: null});
                    return rField;
                  });

                const custom = false;
                const valueDataType = '';
                setSavedSearchValueDateType(field);
                field.operatorsDD = field?.operators?.length>0 ? field.operators.map((o, i) => ({ id: i + 1, name: o })) : [];

                const rField = {
                  label: field.labelName,
                  id: field.id,
                  labelname: field?.labelName,
                  customAttributeObjectId: field?.customAttributeObjectId||null,
                  custom,
                  valueDataType,
                  isSelectableField: childFields.length === 0,
                  ...field,
                  children: childFields
                };

                rField?.isSelectableField && selectableFields.push({...rField,children: null});
                return rField;
              });

            const customFields = item.customFields
              .filter(customField => customField.enableSavedSearchQuery === true)
              .map(customField => {
                const custom = true;
                const valueDataType = '';
                customField.custom = true;
                setSavedSearchValueDateType(customField);

                if(!customField.operators){
                }

                customField.operatorsDD = customField?.operators ? customField.operators.map((o, i) => ({ id: i + 1, name: o })) : [];

                let custompickvalues: any[] = [];
                let typescustom = [];
                typescustom = customField?.formControl?.pickListValues||[];
                for (let l of typescustom) {
                    let name = l;
                    let eachType = {
                        id: name,
                        name: name,
                    }
                    custompickvalues.push(eachType);
                }

                const rField = {
                    label: customField.labelName,
                    id: customField.id,
                    labelname: customField?.labelName,
                    isSelectableField: true,
                    custom,
                    valueDataType,
                    formControl: customField.formControl.type,
                    formControlId: customField.formControl.id,
                    customAttributeObjectId: customField?.customAttributeObjectId||null,
                    pickListValues: JSON.stringify(custompickvalues),
                    ...customField,
                    children: []
                }

                selectableFields.push({...rField,children: null});
                return rField;
              });

            // fields.sort((a, b) => a.label.localeCompare(b.label));
            // customFields.sort((a, b) => a.label.localeCompare(b.label));

            const sortedChildren = [...fields, ...customFields];
            sortedChildren.sort((a, b) => a.label.localeCompare(b.label));


            return {
              label: item.name,
              id: item?.id,
              isSelectableField: false,
              children: sortedChildren
            };
        });

        if((this.selectedAssoModule?.name === "Transactions" || this.selectedAssoModule?.name === "VendorTransaction") && this.filterDDTree?.length>0){
            const transactionOp = [
                "IsEqualTo",
                // "IsNotEqualTo",
                // "HasValue",
                // "NoValue"
            ];

            const transactionType = {
                id: 3399,
                label: "Transaction Type",
                name: "Transaction Type",
                labelName: "Transaction Type",
                labelname: "Transaction Type",
                field: "trans_TransactionType",
                isRequired: false,
                formControl: "DropDownList",
                mapObject: "Transactions",
                enabledInForm: true,
                enableSavedSearchQuery: true,
                enableSavedSearchColumnSetting: true,
                fieldDataType: "Enum",
                valueDataType: "DropdownList",
                isDateWithTime: false,
                isSelectableField: true,
                operatorsDD: transactionOp.map((o, i) => ({ id: i + 1, name: o })),
                operators: transactionOp,
                fields: [],
                customFields: [],
                childFields: [],
                children: []
            };

            this.filterDDTree.push(transactionType);
            selectableFields.push(transactionType);
        }

        this.filterDDFlat = selectableFields;
        this.lastRuleValues.filtersDDTree = ParseHelper.DeepCopy(this.filterDDTree);
        this.prepareFieldObject(this.filterDDFlat,editedRule);
    }

    getFlatArrayFormChilren(members: any[]){
        let children = [];
        return members.map(m => {
          if (m.children && m.children.length) {
            children = [...children, ...m.children];
          }
          return m;
        }).concat(children.length ? this.getFlatArrayFormChilren(children) : children);
    }

    prepareProductFieldObject(temFilters: SavedSearchNS.IField[]){

        const quantityInformation: any[] = [];
        const productInformation: any[] = [];
        const quantityFields = [
            'availableToPickQty','availableToSellQty','backOrder','badQty',
            'backOrder','minQty','maxqty','onOrder','onSO','qtyonhand',
            'reorderqty','reservedQty','committed','returnedQty','shippedQty','prefStock'
        ];
        this.filterTreeView = true;


        temFilters.map(field=>{
            if(quantityFields.includes(field?.field)){
                quantityInformation.push({
                    label: field.labelname,
                    isSelectableField: true,
                    ...field
                });
            }else{
                productInformation.push({
                    label: field.labelname,
                    isSelectableField: true,
                    ...field
                });
            }
        });

        const productFieldTree: any[] = [];

        if(productInformation?.length>0){
            productFieldTree.push({
                label: "Product Information",
                id: 1,
                isSelectableField: false,
                children: productInformation
            })
        }

        if(quantityInformation?.length>0){
            productFieldTree.push({
                label: "Quantity Information",
                id: 1,
                isSelectableField: false,
                children: quantityInformation
            })
        }
        this.filterDDTree = productFieldTree;
        this.lastRuleValues.filtersDDTree = ParseHelper.DeepCopy(this.filterDDTree);
    }

    prepareAddressFieldObject(temFilters: SavedSearchNS.IField[]){

        const addressInformation: any[] = [];
        const otherInformation: any[] = [];
        const addressFields = [
            'addressClassId','addressTypeId','city','state','country',
            'streetAddress1','streetAddress2','zipcode'
        ];
        this.filterTreeView = true;


        temFilters.map(field=>{
            if(addressFields.includes(field?.field)){
                addressInformation.push({
                    label: field.labelname,
                    isSelectableField: true,
                    ...field
                });
            }else{
                otherInformation.push({
                    label: field.labelname,
                    isSelectableField: true,
                    ...field
                });
            }
        });

        const fieldsTree: any[] = [];

        if(otherInformation?.length>0){
            fieldsTree.push({
                label: `${this.selectedParentModule?.name||''} Information`,
                id: 1,
                isSelectableField: false,
                children: otherInformation
            })
        }

        if(addressInformation?.length>0){
            fieldsTree.push({
                label: "Address Information",
                id: 1,
                isSelectableField: false,
                children: addressInformation
            })
        }
        this.filterDDTree = fieldsTree;
        this.lastRuleValues.filtersDDTree = ParseHelper.DeepCopy(this.filterDDTree);
    }

    prepareFieldObject(fieldList: SavedSearchNS.IField[], editedRule: SavedSearchNS.IRuleList,template: SavedSearchNS.ITemplate = null) {
        let temFilters: SavedSearchNS.IField[] = [];
        //process fields
        fieldList?.map(x => {
            if(!x.operators){}
            x.operatorsDD = x.operators?.length>0 ? x.operators.map((o, i) => ({ id: i + 1, name: o })) : [];
            //******if field == null, email,phone, social
            if (x.fieldTypes) {
                let fieldTypesList = x.fieldTypes?.fields?.map(f => {
                    f.fieldDataType = x.fieldDataType;
                    f.operators = x.operators||[];
                    f.field = f.field;
                    f.valueDataType = x.fieldDataType;
                    f.isSelectableField = true;
                    return f;
                });
                if (fieldTypesList) {
                    temFilters.push(...fieldTypesList);
                }
            }
            //Set Value DataType for UI implementation
            setSavedSearchValueDateType(x);
            if (x.field) {
                temFilters.push(x);
            }
        });
        temFilters = temFilters?.map(x => {
            x.operatorsDD = x.operators?.length>0 ? x.operators.map((o, i) => ({ id: i + 1, name: o })) : [];
            return x;
        });

        this.availableFieldsLoaded.emit(temFilters);

        if(template?.objectId==ProductModuleId){
            this.prepareProductFieldObject(temFilters);
        }else if ([EstimateOrderModuleId, InvoiceOrderModuleId, SOModuleId].includes(template?.objectId)){
            this.prepareAddressFieldObject(ParseHelper.DeepCopy(temFilters));
        }

        //****Set Filter Dropdown List
        this.lastRuleValues.filtersDD = ParseHelper.DeepCopy(temFilters);
        if(!this.lastRuleValues.filtersDDTree?.length){
            this.lastRuleValues.filtersDDTree = ParseHelper.DeepCopy(this.lastRuleValues.filtersDD);
        }

        this.availableCompareFields = [
            {
                labelname: "Enter Value",
                name: null,
                field: null
            }
        ];

        const flattedFields = this.lastRuleValues?.filtersDDTree?.length ? this.getFlatArrayFormChilren(this.lastRuleValues.filtersDDTree) : [];
        this.filterDDFlat=flattedFields;
        if(this.filterTreeView){
            const availableCompareFields = flattedFields.filter(field=> ['Number','Decimal','Money'].includes(field?.fieldDataType));
            this.availableCompareFields = [...this.availableCompareFields,...availableCompareFields];
        }else{
            const availableCompareFields = temFilters.filter(field=> ['Number','Decimal','Money'].includes(field?.fieldDataType));
            this.availableCompareFields = [...this.availableCompareFields,...availableCompareFields];
        }

        this.availableCompareFields.map(compareField=>{
            compareField['criteria'] = (!compareField?.custom && compareField.field) ? compareField.field?.charAt(0).toUpperCase() + compareField.field.slice(1) : compareField.name ;
        });

        if (editedRule && this.editRule) {
            if(this.filterTreeView){
                this.lastRuleValues.selectedFilter = flattedFields?.find(x => x.field?.toLowerCase() == editedRule?.filter?.field?.toLowerCase());
            }else{
                this.lastRuleValues.selectedFilter = temFilters?.find(x => x.field?.toLowerCase() == editedRule?.filter?.field?.replace(/ /g, '').toLowerCase());
            }

            this.lastRuleValues.selectedValue = editedRule.value;
            this.lastRuleValues.selectedValue2 = editedRule.value2;
            this.lastRuleValues.selectedChoice = editedRule.choice||this.lastRuleValues.selectedChoice;
            this.lastRuleValues.compareWithField = editedRule?.compareWithField||false;
            this.lastRuleValues.comparisonCriteria = editedRule?.comparisonCriteria||null;
            this.lastRuleValues.comparisonCriteriaLabel = editedRule?.comparisonCriteriaLabel||null;
            this.lastRuleValues.comparisonCriteriaParentLabel = editedRule?.comparisonCriteriaParentLabel||null;
            this.lastRuleValues.isCustomComparisonCriteria = editedRule?.isCustomComparisonCriteria||null;
            this.lastRuleValues.customAttributeObjectId = editedRule?.customAttributeObjectId||null;
            this.lastRuleValues.comparisonCustomAttributeObjectId = editedRule?.comparisonCustomAttributeObjectId||null;

            if(editedRule.filter?.fieldDataType == 'DateTime'){
                if(editedRule.value && editedRule.dataTypeWithOperator?.NoOfValuesToBePassed != 'Between_Value' &&
                (editedRule.dataTypeWithOperator?.Operator != 'Is' || (editedRule.dataTypeWithOperator?.Operator == 'Is' && editedRule.value2?.code == 'custom'))){
                    this.lastRuleValues.selectedValue = new Date(editedRule.value);
                }

                if(editedRule.dataTypeWithOperator?.NoOfValuesToBePassed == 'Between_Value' &&  editedRule.value?.length==2){
                    this.lastRuleValues.selectedValue = [new Date(editedRule.value[0]),new Date(editedRule.value[1])];
                }
            } else if (editedRule.filter?.valueDataType=='User' && editedRule.value && (typeof editedRule.value)=='object'){
                const inactiveUsers = editedRule.value?.filter(user=> user?.statusId!=Status.Active)||[];
                this.users = [...this.users,...inactiveUsers];
            }else if(
                editedRule.filter.valueDataType == 'AutoCompleteDropdown' &&
                !['HasValue','NoValue'].includes(editedRule.operator?.name) &&
                (!editedRule.value?.name && !editedRule.value?.item2) &&
                editedRule.value && (typeof editedRule.value == "string")
            ){
                editedRule.value = {
                    name: editedRule.value,
                    item2:  editedRule.value
                }
            }

            this.selectedEditRule = editedRule;
        }else{
            this.lastRuleValues.selectedFilter = temFilters[0];
            if(this.selectedAssoModule?.name=="Transactions" || this.selectedAssoModule?.name == "VendorTransaction"){
                const transactionType = this.ruleList.find(x => x.filter.field?.toLowerCase() == "trans_transactiontype");
                const transactionTypeData = this.ruleData.find(x => x.filter.field?.toLowerCase() == "trans_transactiontype");
                const transactionTypeSelected: boolean = (transactionType || transactionTypeData) ? true : false;

                if(transactionTypeSelected){
                    this.lastRuleValues.selectedFilter = this.lastRuleValues.filtersDDTree[0].children.find(x=> x.isSelectableField);
                }else{
                    this.lastRuleValues.selectedFilter = this.lastRuleValues.filtersDDTree.find(x=> x.isSelectableField)||this.lastRuleValues.filtersDDTree[0].children.find(x=> x.isSelectableField);
                }

            }else if(this.filterTreeView){
                this.lastRuleValues.selectedFilter = this.lastRuleValues.filtersDDTree[0]?.children.find(x=> x.isSelectableField);
            }else{
                this.lastRuleValues.selectedFilter = temFilters[0];
            }
        }

        this.setDependentTreeFields(editedRule);
        this.onFieldChange(this.lastRuleValues.selectedFilter, editedRule);
    }

    //Add to rule list
    addRuleList() {
        let eachRule: SavedSearchNS.IRuleList = {
            id: 0,
            module: this.isMainModule == true ? this.selectedParentModule : this.selectedAssoModule,
            subModule: this.selectedAssoModule,
            template: this.isMainModule == true ? this.selectedParentTemplate : this.selectedAssoTemplate,
            filter: { ...this.lastRuleValues.selectedFilter },
            operator: this.lastRuleValues.selectedOperator,
            value: this.lastRuleValues.selectedValue,
            value2: this.lastRuleValues.selectedValue2,
            choice: this.lastRuleValues.selectedChoice,
            isMainModule: this.isMainModule,
            dataTypeWithOperator: this.lastRuleValues.selectedDataTypeWithOperator,
            valueLists: this.lastRuleValues.allEnumMultiselect,
            treeValueLists: this.lastRuleValues.treeSelectData,
            objectId: this.isMainModule == true ? this.selectedParentModule.objectId : this.selectedAssoModule.objectId,
            objectName: this.isMainModule == true ? this.selectedParentModule.name : this.selectedAssoModule.name,
            valueRefId: [],
            groupLabel: this.lastRuleValues.selectedGroupLabel,
            groupChildren: this.lastRuleValues.selectedGroupChildren,
            group: this.lastRuleValues.selectedGroup,
            filtersDD: this.lastRuleValues.filtersDD,
            filtersDDTree: _.cloneDeep(this.lastRuleValues.filtersDDTree),
            canEdit: true,
            accountChannel: this.selectedAccountChannel,
            compareWithField: this.lastRuleValues?.compareWithField||false,
            comparisonCriteria: this.lastRuleValues?.comparisonCriteria||null,
            comparisonCriteriaLabel: this.lastRuleValues?.comparisonCriteriaLabel||null,
            comparisonCriteriaParentLabel: this.lastRuleValues?.comparisonCriteriaParentLabel||null,
            isCustomComparisonCriteria: this.lastRuleValues?.isCustomComparisonCriteria||false,
            customAttributeObjectId: this.lastRuleValues?.customAttributeObjectId||null,
            comparisonCustomAttributeObjectId: this.lastRuleValues?.comparisonCustomAttributeObjectId||null,
            comparisonCriteriaObject: this.isMainModule == true ? this.selectedParentModule.name : this.selectedAssoModule.name,
        }

        if(
            eachRule.filter.valueDataType == 'AutoCompleteDropdown' &&
            !['HasValue','NoValue'].includes(eachRule.operator?.name) &&
            (!eachRule.value?.name && !eachRule.value?.item2) &&
            eachRule.value && (typeof eachRule.value == "string")
        ){
            eachRule.value = {
                name: eachRule.value,
                item2:  eachRule.value
            }
        }

        this.ruleList.push(eachRule);
        this.validateAddedRules();
        if(this.filterTreeView){
            this.lastRuleValues.selectedFilter = this.lastRuleValues.filtersDDTree[0].children.find(x=> x.isSelectableField);
        }else{
            this.lastRuleValues.selectedFilter = this.lastRuleValues.filtersDD[0]
        }
        this.lastRuleValues.customAttributeObjectId = this.lastRuleValues?.selectedFilter?.customAttributeObjectId||null;
        this.lastRuleValues.selectedOperator = null;
        this.lastRuleValues.selectedValue = null;
        this.lastRuleValues.selectedValue2 = null;
        this.lastRuleValues.compareWithField = false;
        this.lastRuleValues.comparisonCriteria = null;
        this.lastRuleValues.comparisonCriteriaLabel = null;
        this.lastRuleValues.comparisonCriteriaParentLabel = null;
        this.lastRuleValues.isCustomComparisonCriteria = false;
        this.lastRuleValues.comparisonCustomAttributeObjectId = null;
        //Call Field Change
        this.onFieldChange(this.lastRuleValues.selectedFilter, null);
        this.setDependentTreeFields(null);
    }

    onFieldChangeRuleList(rule: SavedSearchNS.IRuleList) {
        rule.errorMsg = "";
        if (!rule.filter?.isSelectableField && this.filterTreeView){
            rule.errorMsg = `${rule.filter?.label||rule.filter?.labelname} is not a field, please select a correct field`;
            return;
        }

        rule.operator = rule?.filter?.operatorsDD[0] ?? rule.operator;
        rule.customAttributeObjectId = rule?.filter?.customAttributeObjectId||null;
        this.onOperatorChangeRuleList(rule);
        this.getFieldChangeValue(rule.filter, null, 'List', rule);
    }

    onFieldChange(field: SavedSearchNS.IField, editedRule: SavedSearchNS.IRuleList) {
        this.selectedFieldErrorMsg = "";
        if (!field?.isSelectableField && this.filterTreeView){
            this.selectedFieldErrorMsg = `${field?.label||field?.labelname} is not a field, please select a correct field`;
            if(this.editRule && !(field?.label||field?.labelname)){
                this.selectedFieldErrorMsg = `This field is not active to edit, please select a different field`;
            }
            return;
        }

        this.lastRuleValues.selectedGroupChildren = "";
        this.lastRuleValues.selectedGroupLabel = "";
        this.lastRuleValues.selectedGroup = false;
        this.lastRuleValues.customAttributeObjectId = this.lastRuleValues?.selectedFilter?.customAttributeObjectId||null;
        if (editedRule) {
            this.lastRuleValues.selectedOperator = field?.operatorsDD?.find(x => x.name == editedRule.operator.name);
            if (!this.lastRuleValues.selectedOperator) {
                this.lastRuleValues.selectedOperator = field.operatorsDD[0];
            }
        }
        else {
            this.lastRuleValues.selectedOperator = field?.operatorsDD?.[0];
        }
        //Call oprator change
        this.onOperatorChange(field);
        this.getFieldChangeValue(field, editedRule, 'Selected', editedRule);
    }

    validateAddedRules(){
        this.ruleList.map(rule=>{
            this.onChangeRuleFieldValue(rule);
        })
    }

    onChangeRuleFieldValue(rule: any){
        rule['ruleErrorMsg'] = "";
        if(rule?.filter){ //for added rules
            if(rule?.filter?.valueDataType == 'MultiSelect'
                && (!rule?.value || rule?.value?.length==0)
                && rule?.dataTypeWithOperator?.NoOfValuesToBePassed != 'No_Value'){
                rule['ruleErrorMsg'] = "Select any items";
            }
        }else if(rule?.selectedFilter){ //for last rules
            if(rule?.selectedFilter?.valueDataType == 'MultiSelect'
                && (!rule?.selectedValue || rule?.selectedValue?.length==0)
                && rule?.selectedDataTypeWithOperator?.NoOfValuesToBePassed != 'No_Value'){
                rule['ruleErrorMsg'] = "Select any items";
            }
        }
    }

    selectChoice(event: any){
        this.savedSearchRulesDataService.choiceChange(event.value);
    }

    changeAllChoiceConditionally(selectedChoice: any){
        this.ruleList.map(item=>{
            item.choice = selectedChoice;
        });

        this.lastRuleValues.selectedChoice = selectedChoice;
    }

    getFieldChangeValue(field: SavedSearchNS.IField, editedRule: SavedSearchNS.IRuleList, changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList) {
        // console.log(field)
        //****Custom Field */
        if (field.custom == true) {
            if (
                // field.fieldDataType == 'Enum' ||
                field?.formControlId == CUSTOMFIELD_TYPE_IDS.MULTISELECT ||
                field?.formControlId == CUSTOMFIELD_TYPE_IDS.DROPDOWN ||
                field?.formControlId == CUSTOMFIELD_TYPE_IDS.CHECKBOX ||
                field?.formControlId == CUSTOMFIELD_TYPE_IDS.RADIO_BUTTON) {
                let custompickvalues = [];
                let typescustom = [];
                typescustom = JSON.parse((field.pickListValues));
                for (let l of typescustom) {
                    let name = l?.name ? l.name : l?.Name;
                    let eachType = {
                        id: name,
                        name: name,
                    }
                    custompickvalues.push(eachType);
                }
                if (changeType == 'Selected') {
                    this.lastRuleValues.allEnumMultiselect = custompickvalues;
                }
                else if (changeType == 'List') {
                    rule.valueLists = custompickvalues;
                }
            }
            else if (field?.formControlId == CUSTOMFIELD_TYPE_IDS.RATING || field?.formControlId == CUSTOMFIELD_TYPE_IDS.USERLOOKUP) {
                let custompickvalues = RatingValueObjects;

                if(field?.formControlId == CUSTOMFIELD_TYPE_IDS.USERLOOKUP){
                    custompickvalues = this.users;
                }

                if (changeType == 'Selected') {
                    this.lastRuleValues.allEnumMultiselect = custompickvalues;

                    if(editedRule?.value){
                        const selectedValues = [];

                        this.lastRuleValues.allEnumMultiselect.map(rating=>{
                            const exist = editedRule?.value?.find(x=> x.name==rating.name);
                            exist && selectedValues.push(rating);
                        });
                        editedRule.value = selectedValues;
                        this.lastRuleValues.selectedValue = selectedValues;
                    }
                }
                else if (changeType == 'List') {
                    rule.valueLists = custompickvalues;
                }
            }
        }
        else {
            this.lastRuleValues.allEnumMultiselect = [];
            if (field.field?.toLowerCase() == "accounttypesname") {
                this.getAllAccountTypes(changeType, rule);
            } else if (field.field?.toLowerCase() == "tags") {
                this.getAllTags(changeType, rule);
            } else if (['sourcename'].includes(field.field?.toLowerCase())) {
                if (this.selectedParentModule.name.toLowerCase() == SavedSearchParentModule.Lead?.toLowerCase()) {
                    this.getAllLeadSource(changeType, rule);
                }
                else if (this.selectedParentModule.name.toLowerCase() == SavedSearchParentModule.Account?.toLowerCase()) {
                    this.getAllAccountSource(changeType, rule);
                }
                else if (this.selectedParentModule.name.toLowerCase() == SavedSearchParentModule.Opportunity?.toLowerCase()) {
                    this.getOpportunitySources(changeType, rule);
                }
            } else if (['opportunity_source'].includes(field.field?.toLowerCase())) {
                this.getOpportunitySources(changeType, rule);
            } else if (['noofemployees','employeesrangename'].includes(field.field?.toLowerCase())) {
                this.getAllEmployeesCount(changeType, rule);
            } else if (['estimatedannualrevenue','annualrevenuename'].includes(field.field?.toLowerCase())) {
                this.getAllAnnualRevenue(changeType, rule);
            } else if (['ownershiptype','ownershipname'].includes(field.field?.toLowerCase())) {
                this.getAllOwners(changeType, rule);
            } else if (['opportunity_addressclass','trans_addressclass','addressclassid'].includes(field.field?.toLowerCase())) {
                this.getAccountAddressClass(changeType, rule);
            } else if (['opportunity_addresstype','trans_addresstype','addresstypeid'].includes(field.field?.toLowerCase())) {
                this.getAccountAddressTypes(changeType, rule);
            } else if (['activeinactivestatus'].includes(field.field?.toLowerCase())) {
                this.getActiveInactiveStatus(changeType, rule, this.selectedParentModule.objectId);
            } else if (['contactactiveinactivestatus'].includes(field.field?.toLowerCase())) {
                this.getActiveInactiveStatus(changeType, rule, ContactModuleId);
            } else if (['relationtype'].includes(field.field?.toLowerCase())) {
                this.getRelationTypes(changeType, rule);
            } else if (['stagename','currentstage','previousstage'].includes(field.field?.toLowerCase())) {
                this.getAllStages(changeType, rule, this.selectedParentModule.objectId, this.selectedParentTemplate.id);
            } else if (['opportunity_stage'].includes(field.field?.toLowerCase())) {
                this.getAllStages(changeType, rule, OpportunityModuleId, this.selectedParentTemplate.id);
            } else if (field.field?.toLowerCase() == "classificationame") {
                // this.getAllClassification(changeType, rule);
                if (this.selectedParentModule.name.toLowerCase() == SavedSearchParentModule.Account?.toLowerCase()) {
                    this.getAllStages(changeType, rule, this.selectedParentModule.objectId, this.selectedParentTemplate.id);
                }
            } else if (['timezone','timezonename'].includes(field.field?.toLowerCase())) {
                this.getAllTimezones(changeType, rule);
            } else if (['industryname','industry'].includes(field.field?.toLowerCase())) {
                this.getAllIndustries(changeType, rule);
            }
            else if (field.field?.toLowerCase() == 'leadtypesname') {
                this.getAllLeadTypes(changeType, rule);
            } else if (field.field?.toLowerCase() == "leadsstatus") {
                this.getAllLeadStatus(changeType, rule);
            } else if (['opportunity_country','trans_location_country','country','trans_billing_country','trans_shipping_country','trans_address_country'].includes(field.valueDataType?.toLowerCase())) {
                this.getCountryByTemplateId(changeType, rule, editedRule);
            } else if (['state'].includes(field.field?.toLowerCase())) {
                this.getStatesByCountry(changeType, rule, editedRule);
            } else if (['opportunity_state'].includes(field.field?.toLowerCase())) {
                this.getStatesByCountry(changeType, rule, editedRule, 'opportunity_');
            } else if (['trans_location_state'].includes(field.field?.toLowerCase())) {
                this.getStatesByCountry(changeType, rule, editedRule, 'trans_location_');
            }  else if (['trans_billing_state'].includes(field.field?.toLowerCase())) {
                this.getStatesByCountry(changeType, rule, editedRule, 'trans_billing_');
            } 
             else if (['trans_shipping_state'].includes(field.field?.toLowerCase())) {
                this.getStatesByCountry(changeType, rule, editedRule, 'trans_shipping_');
            } 
            else if (['trans_address_state'].includes(field.field?.toLowerCase())) {
                this.getStatesByCountry(changeType, rule, editedRule, 'trans_address_');
            } 
            else if (['city'].includes(field.field?.toLowerCase())) {
                this.getCityByStateList(changeType, rule, editedRule);
            } else if (['trans_location_city'].includes(field.field?.toLowerCase())) {
                this.getCityByStateList(changeType, rule, editedRule, 'trans_location_');
            } 
            else if (['trans_billing_city'].includes(field.field?.toLowerCase())) {
                this.getCityByStateList(changeType, rule, editedRule, 'trans_billing_');
            }
            else if (['trans_shipping_city'].includes(field.field?.toLowerCase())) {
                this.getCityByStateList(changeType, rule, editedRule, 'trans_shipping_');
            }
            else if (['trans_address_city'].includes(field.field?.toLowerCase())) {
                this.getCityByStateList(changeType, rule, editedRule, 'trans_address_');
            }
            else if (['opportunity_city'].includes(field.field?.toLowerCase())) {
                this.getCityByStateList(changeType, rule, editedRule, 'opportunity_');
            } else if (['currency','currencyname','currencyunitid'].includes(field.field?.toLowerCase())) {
                this.getCurrencyList(changeType, rule);
            } else if (['languagespoken'].includes(field.field?.toLowerCase())) {
                this.getLanguageList(changeType, rule);
            } else if (field.field?.toLowerCase() == "ratingname") {
                this.getAllRatings(changeType, rule);
            } else if (field.field?.toLowerCase() == "title") {
                this.getSalutations(changeType, rule);
            } else if (['gender','trans_sales_rep_gender','trans_created_by_gender','gender'].includes(field.field?.toLowerCase())) {
                this.getGenders(changeType, rule);
            } else if (field.field?.toLowerCase() == "jobfunction") {
                this.getJobFunction(changeType, rule);
            } else if (field.field?.toLowerCase() == "territoryname") {
                this.getAllCountryTerriList(changeType, rule);
            } else if (field.field?.toLowerCase() == "territorycontact" || field.field?.toLowerCase() == "territoryothercontact") {
                this.getTerritoryUsers(changeType, rule);
            } else if (['trans_sales_rep_role','trans_updated_by_role','trans_created_by_role'].includes(field.field?.toLowerCase())) {
                this.getUserRoles(changeType, rule);
            } else if (['trans_sales_rep_jobtype','trans_updated_by_jobType','trans_created_by_jobtype'].includes(field.field?.toLowerCase())) {
                this.getUserJobTypes(changeType, rule);
            } else if (['trans_sales_rep_department','trans_updated_by_department','trans_created_by_department'].includes(field.field?.toLowerCase())) {
                this.getUserDepartments(changeType, rule);
            } else if (['trans_sales_rep_workinglocation','trans_updated_by_workinglocation','trans_created_by_workinglocation'].includes(field.field?.toLowerCase())) {
                this.getUserWorkingLocations(changeType, rule);
            }
            else if (['addresstype','trans_address_type'].includes(field.field?.toLowerCase())) {
                this.getVendorAddressType(changeType, rule);
            }
            //Estimate
            else if (['trans_location','trans_location_locationname','warehouseid'].includes(field.field?.toLowerCase())) {
                this.getAllWarehouse(changeType, rule);
            } else if (['trans_location_locationid'].includes(field.field?.toLowerCase())) {
                this.getAllWarehouse(changeType, rule, 'locationId');
            } else if (['locationtype','locationgroup','locationcategory','trans_location_type','trans_location_group','trans_location_category','vendortype','businessclassification'].includes(field.field?.toLowerCase())) {
                this.getInventoryGroup(field.field?.toLowerCase(), changeType, rule);
            } else if (['trans_paymentterm','paymenttermid','paymenttermname','paymentterm','preferredpaymentterm','payterm'].includes(field.field?.toLowerCase())) {
                        if(this.selectedParentModule?.objectId === VendorModuleId){
                            this.getVendorPaymentTermList(changeType, rule);
                        }else{
                            this.getPaymentTermList(changeType, rule);
                        }

            } else if (['trans_paymentmethod','paymentmethodid','paymentmethod','preferredpaymentmethod','paymethod'].includes(field.field?.toLowerCase())) {
                if(this.selectedParentModule?.objectId === VendorModuleId){
                    this.getVendorPaymentMethodList(changeType, rule);
                }else{
                    this.getPaymentMrthodList(changeType, rule);
                }

            } else if (['trans_shippingterm','shippingtermid','shippingterm'].includes(field.field?.toLowerCase())) {
                this.getShippingTermList(changeType, rule);
            } else if (['trans_shippingmethod','shippingmethodid','shippingmethod','preferredshippingmethod'].includes(field.field?.toLowerCase())) {
                this.getShippingMethodList(changeType, rule);
            } else if (['discounttypeid','trans_total_discount_discountby','trans_item_discount_discountby','transactionlinehandlingfeesfeetype','transactionhandlingfeesfeetype'].includes(field.field?.toLowerCase())) {
                this.getInventoryGroup('discount', changeType, rule);
            } else if (['trans_item_discount_name','trans_total_discount_name'].includes(field.field?.toLowerCase())) {
                this.getDiscounts(changeType, rule);
            } else if (['transactionhandlingfeesname','transactionlinehandlingfeesname'].includes(field.field?.toLowerCase())) {
                this.getHandlingFees(changeType, rule);
            } else if (field.field?.toLowerCase() == "taxtypeid" || field.field?.toLowerCase() == "taxid") {
                this.getTaxList(changeType, rule);
            }
            else if (field.field?.toLowerCase() == "accountid") {
                // this.getAccountList(changeType, rule, editedRule);
            } else if (['trans_transactiontype','trans_prod_transaction_action','trans_prod_transaction_type'].includes(field.field?.toLowerCase())) {
                this.getTransactionTypes(changeType, rule,field.field?.toLowerCase());
            }
            else if (['trans_item_item','item','productname'].includes(field.field?.toLowerCase())) {
                this.getProductMinified(changeType, rule);
            } else if (['trans_estimatestatus','estimatestatusid'].includes(field.field?.toLowerCase())) {
                this.getEstimateStatus(changeType, rule);
            } else if (['trans_orderstatus','orderstatusid'].includes(field.field?.toLowerCase())) {
                this.getOrderStatus(changeType, rule);
            } else if (['trans_paymentstatus','paymentstatusid','trans_paymentduestatus'].includes(field.field?.toLowerCase())) {
                this.getPaymentStatus(changeType, rule);
            } else if (['trans_deliverystatus','shipmentstatusid'].includes(field.field?.toLowerCase())) {
                this.getShipmentStatus(changeType, rule);
            } else if (['opportunity_quality','quality'].includes(field.field?.toLowerCase())) {
                this.getOpportunityRatings(changeType, rule);
            } else if (['opportunity_forecastcategory','forcastcategory'].includes(field.field?.toLowerCase())) {
                this.getForecastCategories(changeType, rule);
            } else if (field.field?.toLowerCase() == "salesorderstatusid") {
                this.getSalesOrderStatus(changeType, rule);
            } else if (['trans_orderstage','salesorderstageid'].includes(field.field?.toLowerCase())) {
                this.getSalesOrderStage(changeType, rule);
            } else if (field.field?.toLowerCase() == "taxable") {
                this.getTaxablePreference(changeType, rule);
            } else if (['trans_item_product_itemtype','typeid'].includes(field.field?.toLowerCase())) {
                this.getConfigData('type', 'product', changeType, rule);
            }
            else if (['trans_item_product_itemno'].includes(field.field?.toLowerCase())) {
                this.searchAllItemNo({event: ''}, changeType,rule, field.field);
            }else if (['trans_item_product_brand','brandid'].includes(field.field?.toLowerCase())) {
                this.getBrandList(changeType, rule);
            } else if (['trans_item_product_preferredvendor','vendorid'].includes(field.field?.toLowerCase())) {
                this.getVendor('vendor', changeType, rule);
            } else if (['trans_item_product_manufacturer','manufacturerid'].includes(field.field?.toLowerCase())) {
                this.getVendor('manufacturer', changeType, rule);
            } else if (['variant','trans_item_product_variant'].includes(field.field?.toLowerCase())) {
                this.getInventoryGroup('variant', changeType, rule);
            } else if (['trans_item_product_lwhuom','lwhunitofmeasurementid'].includes(field.field?.toLowerCase())) {
                this.getInventoryGroup('height', changeType, rule)
            } else if (['trans_item_product_wuom','wunitofmeasuremetid'].includes(field.field?.toLowerCase())) {
                this.getInventoryGroup('weight', changeType, rule)
            } else if (['assetaccountid','trans_item_product_assetaccount'].includes(field.field?.toLowerCase())) {
                this.loadAllFinancialAccounts('Assets', changeType, rule);
            } else if (['trans_item_product_cogsaccount','cogs'].includes(field.code?.toLowerCase())) {
                this.loadAllFinancialAccounts('Cost of Good Sold (COGS)', changeType, rule);
            } else if (['trans_item_product_incomeaccount','incomeaccountid'].includes(field.field?.toLowerCase())) {
                this.loadAllFinancialAccounts('Income', changeType, rule);
            } else if (field.code?.toLowerCase() == 'expensecogs') {
                this.loadAllFinancialAccounts('Expenses', changeType, rule);
            } else if (field.code?.toLowerCase() == 'chartsofaccounts') {
                this.loadAllFinancialAccounts('Chart of Accounts', changeType, rule);
            }
            else if(['trans_item_expenseaccount','billfinancialaccount'].includes(field.field?.toLowerCase())) {
                this.loadAllFinancialAccounts('Chart of Accounts', changeType, rule);
            }
            else if(['trans_discountaccount'].includes(field.field?.toLowerCase())) {
                this.loadAllFinancialAccounts('Chart of Accounts', changeType, rule);
            }
            else if (['trans_item_product_class','classid','class'].includes(field.field?.toLowerCase())) {
                this.getAllClass(changeType, rule);
            } else if (['trans_item_product_category','category'].includes(field.field?.toLowerCase())) {
                this.getInventoryGroup('category', changeType, rule);
            } else if (['opportunity_item_uom','trans_item_uom','trans_item_product_uom','uom'].includes(field.field?.toLowerCase())) {
                this.getUnitOfMeasures(changeType, rule);
            }

            //Activity module
            else if (field.field?.toLowerCase() == "type") {
                this.getActivityTypes(changeType, rule);
            } else if (field.field?.toLowerCase() == "logtype") {
                this.getActivityLogTypes(changeType, rule);
            } else if (field.field?.toLowerCase() == "logsubtype") {
                this.getActivitySubLogTypes(changeType, rule, editedRule);
            }
            else if (field.field?.toLowerCase() == "associatedmodulename") {
                this.getActivityModules(changeType, rule);
            } else if (field.field?.toLowerCase() == "associatedchannelname") {
                this.getChannelList(changeType, rule, editedRule);
            }

            //Task Module
            else if (field.field?.toLowerCase() == "taskcategory") {
                this.getTaskCategories(changeType, rule);
            }
            else if (field.field?.toLowerCase() == "completionstatus") {
                this.fetchTaskStatuses(changeType, rule);
            }
            else if  (field.field?.toLowerCase() == "priority") {
                this.getTaskPriority(changeType, rule);
            }
            else if (field.field?.toLowerCase() == "relatedto") {
                this.getTaskAssociation(changeType, rule);
            }
            else if (field.field?.toLowerCase() == "status") {
                const objectId = this.selectedAssoModule?.objectId;
                switch (objectId) {
                    case PurchaseOrderModuleId:
                        this.getPurchaseOrderStatus(changeType, rule);
                        break;
                    case BillPaymentModuleId:
                        this.getVendorBillPaymentStatus(changeType, rule);
                        break;
                    case VendorReturnModuleId:
                        this.getVendorRMAStatus(changeType, rule);
                        break;
                }
            }
            else if (field.field?.toLowerCase() == "payment") {

                this.getVendorPaymentReceiptsPaymentStatus(changeType, rule);
            }
            else if (field.field?.toLowerCase() == "billstatus") {
                this.getBillStatus(changeType, rule);
            }
            else if (field.field?.toLowerCase() == "billpaymentstatus") {
                this.getBillPaymentStatus(changeType, rule);
            }
            else if (field.field?.toLowerCase() == "taskstatus") {
                this.fetchTaskStatuses(changeType, rule);
            }
            else if (field.field?.toLowerCase() == "channel") {
                this.getChanneTasklList(changeType, rule, editedRule);
            }
            else if (field.field?.toLowerCase() == "tasktype") {
                this.getTaskType(changeType, rule);
            }
            else if(['trans_billstatus'].includes(field.field?.toLowerCase())) {
                this.getVendorBillStatus(changeType, rule);
            }
            else if(['trans_vrmastatus'].includes(field.field?.toLowerCase())) {
                this.getVendorRMAStatus(changeType, rule);
            }
            else if(['trans_vendorcreditstatus'].includes(field.field?.toLowerCase())) {
                this.getVendorCreditStatus(changeType, rule);
            }
            else if(['stage'].includes(field.field?.toLowerCase())) {
                this.getVendorTransactionStage(changeType, rule);
            }
            else if(['trans_billpaymentstatus'].includes(field.field?.toLowerCase())) {
                this.getVendorBillPaymentStatus(changeType, rule);
            }
            else if(['isactive'].includes(field.field?.toLowerCase())) {
                this.getPurchaseOrderIsActive(changeType, rule);
            }
            else if(['trans_aging_stage'].includes(field.field?.toLowerCase())) {
                this.getAgingStatus(changeType, rule);
            }
            else if(['contact_roles'].includes(field.field?.toLowerCase())) {
                this.loadContactRoles(changeType, rule);
            }
            else if(['requesttype'].includes(field.field?.toLowerCase())) {
                this.getAllReturnTypes(changeType, rule);
            }
            else if(['reason'].includes(field.field?.toLowerCase())) {
                this.getAllResons(changeType, rule);
            }
            else if(['returnfromlocation'].includes(field.field?.toLowerCase())) {
                this.getVendorRMALocation(changeType, rule);
            }
        }
    }


    //Set Activity dependent fields
    setDependentTreeFields(editedRule: SavedSearchNS.IRuleList){

        //Address
        const country = this.ruleList.find(x => x.filter.field?.toLowerCase() == "country" && x.operator?.name=="IsEqualTo");
        const countryData = this.ruleData.find(x => x.filter.field?.toLowerCase() == "country" && x.operator?.name=="IsEqualTo");
        const countrySelcted: boolean = (country || countryData) ? true : false;

        const state = this.ruleList.find(x => x.filter.field?.toLowerCase() == "state" && x.operator?.name=="IsEqualTo");
        const stateData = this.ruleData.find(x => x.filter.field?.toLowerCase() == "state" && x.operator?.name=="IsEqualTo");
        const stateSelcted: boolean = (state || stateData) ? true : false;

        //Transaction Address
        const trans_location_country = this.ruleList.find(x => x.filter.field?.toLowerCase() == "trans_location_country" && x.operator?.name=="IsEqualTo");
        const trans_location_countryData = this.ruleData.find(x => x.filter.field?.toLowerCase() == "trans_location_country" && x.operator?.name=="IsEqualTo");
        const trans_location_countrySelcted: boolean = (trans_location_country || trans_location_countryData) ? true : false;

        const trans_location_state = this.ruleList.find(x => x.filter.field?.toLowerCase() == "trans_location_state" && x.operator?.name=="IsEqualTo");
        const trans_location_stateData = this.ruleData.find(x => x.filter.field?.toLowerCase() == "trans_location_state" && x.operator?.name=="IsEqualTo");
        const trans_location_stateSelcted: boolean = (trans_location_state || trans_location_stateData) ? true : false;

        //Transaction Billing Address
        const trans_billing_country = this.ruleList.find(x => x.filter.field?.toLowerCase() == "trans_billing_country" && x.operator?.name=="IsEqualTo");
        const trans_billing_countryData = this.ruleData.find(x => x.filter.field?.toLowerCase() == "trans_billing_country" && x.operator?.name=="IsEqualTo");
        const trans_billing_countrySelcted: boolean = (trans_billing_country || trans_billing_countryData) ? true : false;
  
        const trans_billing_state = this.ruleList.find(x => x.filter.field?.toLowerCase() == "trans_billing_state" && x.operator?.name=="IsEqualTo");
        const trans_billing_stateData = this.ruleData.find(x => x.filter.field?.toLowerCase() == "trans_billing_state" && x.operator?.name=="IsEqualTo");
        const trans_billing_stateSelcted: boolean = (trans_billing_state || trans_billing_stateData) ? true : false;

        // Transaction Address
        const trans_address_country = this.ruleList.find(x => x.filter.field?.toLowerCase() == "trans_address_country" && x.operator?.name=="IsEqualTo");
        const trans_address_countryData = this.ruleData.find(x => x.filter.field?.toLowerCase() == "trans_address_country" && x.operator?.name=="IsEqualTo");
        const trans_address_countrySelcted: boolean = (trans_address_country || trans_address_countryData) ? true : false;
          
        const trans_address_state = this.ruleList.find(x => x.filter.field?.toLowerCase() == "trans_address_state" && x.operator?.name=="IsEqualTo");
        const trans_address_stateData = this.ruleData.find(x => x.filter.field?.toLowerCase() == "trans_address_state" && x.operator?.name=="IsEqualTo");
        const trans_address_stateSelcted: boolean = (trans_address_state || trans_address_stateData) ? true : false;

        // Transaction Shipping Address 
        const trans_shipping_country = this.ruleList.find(x => x.filter.field?.toLowerCase() == "trans_shipping_country" && x.operator?.name=="IsEqualTo");
        const trans_shipping_countryData = this.ruleData.find(x => x.filter.field?.toLowerCase() == "trans_shipping_country" && x.operator?.name=="IsEqualTo");
        const trans_shipping_countrySelcted: boolean = (trans_shipping_country || trans_shipping_countryData) ? true : false;
          
        const trans_shipping_state = this.ruleList.find(x => x.filter.field?.toLowerCase() == "trans_shipping_state" && x.operator?.name=="IsEqualTo");
        const trans_shipping_stateData = this.ruleData.find(x => x.filter.field?.toLowerCase() == "trans_shipping_state" && x.operator?.name=="IsEqualTo");
        const trans_shipping_stateSelcted: boolean = (trans_shipping_state || trans_shipping_stateData) ? true : false;



        //Activity associatedModuleName, associatedChannelName, associationName

        const associatedModule = this.ruleList.find(x => x.filter.field?.toLowerCase() == "associatedmodulename" && x.operator?.name=="IsEqualTo");
        const associatedModuleData = this.ruleData.find(x => x.filter.field?.toLowerCase() == "associatedmodulename" && x.operator?.name=="IsEqualTo");
        const associatedModuleSelcted: boolean = (associatedModule || associatedModuleData) ? true : false;

        const associatedChannel = this.ruleList.find(x => x.filter.field?.toLowerCase() == "associatedchannelname" && x.operator?.name=="IsEqualTo");
        const associatedChannelData = this.ruleData.find(x => x.filter.field?.toLowerCase() == "associatedchannelname" && x.operator?.name=="IsEqualTo");
        const associatedChannelSelected = (associatedChannel || associatedChannelData) ? true : false;

        //Task associatedModuleName, associatedChannelName, associationName

        const associatedTaskModule = this.ruleList.find(x => x.filter.field?.toLowerCase() == "relatedto" && x.operator?.name=="IsEqualTo");
        const associatedTaskModuleData = this.ruleData.find(x => x.filter.field?.toLowerCase() == "relatedto" && x.operator?.name=="IsEqualTo");
        const associatedTaskModuleSelcted: boolean = (associatedTaskModule || associatedTaskModuleData) ? true : false;

        const associatedTaskChannel = this.ruleList.find(x => x.filter.field?.toLowerCase() == "channel" && x.operator?.name=="IsEqualTo");
        const associatedTaskChannelData = this.ruleData.find(x => x.filter.field?.toLowerCase() == "channel" && x.operator?.name=="IsEqualTo");
        const associatedTaskChannelSelected = (associatedTaskChannel || associatedTaskChannelData) ? true : false;

        // const activityType = this.ruleList.find((rule, index) => rule.filter?.field?.toLowerCase() == "type" && (((rule.value?.length>0 && rule.operator?.name=="IsEqualTo") && rule.value?.find(l=> ['Log'].includes(l?.name))) || rule.operator?.name=="HasValue"));
        // const activityTypeData = this.ruleData.find((rule, index) => rule.filter?.field?.toLowerCase() == "type" && (((rule.value?.length>0 && rule.operator?.name=="IsEqualTo") && rule.value?.find(l=> ['Log'].includes(l?.name))) || rule.operator?.name=="HasValue"));
        // const activityTypeSelected = (activityType || activityTypeData) ? true : false;

        const logtype = this.ruleList.find((rule, index) => rule.filter?.field?.toLowerCase() == "logtype" && ((rule.value?.length>0 && rule.operator?.name=="IsEqualTo") && rule.value?.find(l=> ['Mobile','Work'].includes(l?.name))));
        const logtypeData = this.ruleData.find((rule, index) => rule.filter?.field?.toLowerCase() == "logtype" && ((rule.value?.length>0 && rule.operator?.name=="IsEqualTo") && rule.value?.find(l=> ['Mobile','Work'].includes(l?.name))));
        const logtypeSelected = (logtype || logtypeData) ? true : false;

        const transactionType = this.ruleList.find(x => x.filter.field?.toLowerCase() == "trans_transactiontype");
        const transactionTypeData = this.ruleData.find(x => x.filter.field?.toLowerCase() == "trans_transactiontype");
        const transactionTypeSelected: boolean = (transactionType || transactionTypeData) ? true : false;

        this.lastRuleValues.filtersDDTree.map(section=>{

            if(this.selectedAssoModule?.name=="Transactions" || this.selectedAssoModule?.name=="VendorTransaction"){
                if(section?.field?.toLowerCase() != "trans_transactiontype"){
                    section['styleClass'] = (!transactionTypeSelected || (editedRule && editedRule.filter.field?.toLowerCase() == "trans_transactiontype")) ? "treeselect-row-hidden" : "";
                }

                if(section?.field?.toLowerCase() == "trans_transactiontype"){
                    section['styleClass'] = (!transactionTypeSelected || (editedRule && editedRule.filter.field?.toLowerCase() == "trans_transactiontype")) ? "" : "treeselect-row-hidden";
                }
            }

            if(section?.children?.length>0){
                section?.children.map(field=>{
                    //Address
                    if(field.field?.toLowerCase() == "country"){
                        field.styleClass = (!countrySelcted || (editedRule && editedRule.filter.field?.toLowerCase() == "country")) ? "" : "treeselect-row-hidden";
                    }

                    if(field.field?.toLowerCase() == "state"){
                        field.styleClass = (((countrySelcted && !stateSelcted) || (editedRule && editedRule.filter.field?.toLowerCase() == "state")) && (editedRule?.filter?.field?.toLowerCase() != "country")) ? "" : "treeselect-row-hidden";
                    }

                    if(field.field?.toLowerCase() == "city"){
                        field.styleClass = ((stateSelcted || (editedRule && editedRule.filter.field?.toLowerCase() == "city")) && (editedRule?.filter?.field?.toLowerCase() != "state")) ? "" : "treeselect-row-hidden";
                    }

                    //Address
                    if(field.field?.toLowerCase() == "trans_location_country"){
                        field.styleClass = (!trans_location_countrySelcted || (editedRule && editedRule.filter.field?.toLowerCase() == "trans_location_country")) ? "" : "treeselect-row-hidden";
                    }

                    if(field.field?.toLowerCase() == "trans_location_state"){
                        field.styleClass = (((trans_location_countrySelcted && !trans_location_stateSelcted) || (editedRule && editedRule.filter.field?.toLowerCase() == "trans_location_state")) && (editedRule?.filter?.field?.toLowerCase() != "trans_location_country")) ? "" : "treeselect-row-hidden";
                    }

                    if(field.field?.toLowerCase() == "trans_location_city"){
                        field.styleClass = ((trans_location_stateSelcted || (editedRule && editedRule.filter.field?.toLowerCase() == "trans_location_city")) && (editedRule?.filter?.field?.toLowerCase() != "trans_location_state")) ? "" : "treeselect-row-hidden";
                    }

                    //billing
                    if(field.field?.toLowerCase() == "trans_billing_country"){
                        field.styleClass = (!trans_billing_countrySelcted || (editedRule && editedRule.filter.field?.toLowerCase() == "trans_billing_country")) ? "" : "treeselect-row-hidden";
                    }

                    if(field.field?.toLowerCase() == "trans_billing_state"){
                        field.styleClass = (((trans_billing_countrySelcted && !trans_billing_stateSelcted) || (editedRule && editedRule.filter.field?.toLowerCase() == "trans_billing_state")) && (editedRule?.filter?.field?.toLowerCase() != "trans_billing_country")) ? "" : "treeselect-row-hidden";
                    }

                    if(field.field?.toLowerCase() == "trans_billing_city"){
                        field.styleClass = ((trans_billing_stateSelcted || (editedRule && editedRule.filter.field?.toLowerCase() == "trans_billing_city")) && (editedRule?.filter?.field?.toLowerCase() != "trans_billing_state")) ? "" : "treeselect-row-hidden";
                    }
                    //

                     //shipping 
                    if(field.field?.toLowerCase() == "trans_shipping_country"){
                        field.styleClass = (!trans_shipping_countrySelcted || (editedRule && editedRule.filter.field?.toLowerCase() == "trans_shipping_country")) ? "" : "treeselect-row-hidden";
                    }
                
                    if(field.field?.toLowerCase() == "trans_shipping_state"){
                     field.styleClass = (((trans_shipping_countrySelcted && !trans_shipping_stateSelcted) || (editedRule && editedRule.filter.field?.toLowerCase() == "trans_shipping_state")) && (editedRule?.filter?.field?.toLowerCase() != "trans_shipping_country")) ? "" : "treeselect-row-hidden";
                     }
                
                    if(field.field?.toLowerCase() == "trans_shipping_city"){
                     field.styleClass = ((trans_shipping_stateSelcted || (editedRule && editedRule.filter.field?.toLowerCase() == "trans_shipping_city")) && (editedRule?.filter?.field?.toLowerCase() != "trans_shipping_state")) ? "" : "treeselect-row-hidden";
                     }
                    // address

                    if(field.field?.toLowerCase() == "trans_address_country"){
                        field.styleClass = (!trans_address_countrySelcted || (editedRule && editedRule.filter.field?.toLowerCase() == "trans_address_country")) ? "" : "treeselect-row-hidden";
                    }
                
                    if(field.field?.toLowerCase() == "trans_address_state"){
                     field.styleClass = (((trans_address_countrySelcted && !trans_address_stateSelcted) || (editedRule && editedRule.filter.field?.toLowerCase() == "trans_address_state")) && (editedRule?.filter?.field?.toLowerCase() != "trans_address_country")) ? "" : "treeselect-row-hidden";
                     }
                
                    if(field.field?.toLowerCase() == "trans_address_city"){
                     field.styleClass = ((trans_address_stateSelcted || (editedRule && editedRule.filter.field?.toLowerCase() == "trans_address_city")) && (editedRule?.filter?.field?.toLowerCase() != "trans_address_state")) ? "" : "treeselect-row-hidden";
                     }
                    // 

                    //Activity
                    if(field.field?.toLowerCase() == "associatedmodulename"){
                        field.styleClass = (!associatedModuleSelcted || (editedRule && editedRule.filter.field?.toLowerCase() == "associatedmodulename")) ? "" : "treeselect-row-hidden";
                    }

                    if(field.field?.toLowerCase() == "associatedchannelname"){
                        field.styleClass = (((associatedModuleSelcted && !associatedChannelSelected) || (editedRule && editedRule.filter.field?.toLowerCase() == "associatedchannelname")) && (editedRule?.filter?.field?.toLowerCase() != "associatedmodulename")) ? "" : "treeselect-row-hidden";
                    }

                    if(field.field?.toLowerCase() == "associationname"){
                        field.styleClass = ((associatedChannelSelected || (editedRule && editedRule.filter.field?.toLowerCase() == "associationname")) && (editedRule?.filter?.field?.toLowerCase() != "associatedchannelname")) ? "" : "treeselect-row-hidden";
                    }


                    if(field.field?.toLowerCase() == "logsubtype"){
                        field.styleClass = ((logtypeSelected || (editedRule && editedRule.filter.field?.toLowerCase() == "logsubtype")) && (editedRule?.filter?.field?.toLowerCase() != "logtype")) ? "" : "treeselect-row-hidden";
                    }

                    //Task Saved-search

                    if(field.field?.toLowerCase() == "relatedto"){
                        field.styleClass = (!associatedTaskModuleSelcted || (editedRule && editedRule.filter.field?.toLowerCase() == "relatedto")) ? "" : "treeselect-row-hidden";
                    }

                    if(field.field?.toLowerCase() == "channel"){
                        field.styleClass = (((associatedTaskModuleSelcted && !associatedTaskChannelSelected) || (editedRule && editedRule.filter.field?.toLowerCase() == "channel")) && (editedRule?.filter?.field?.toLowerCase() != "associatedmodulename")) ? "" : "treeselect-row-hidden";
                    }

                    if(field.field?.toLowerCase() == "association"){
                        field.styleClass = ((associatedTaskChannelSelected || (editedRule && editedRule.filter.field?.toLowerCase() == "association")) && (editedRule?.filter?.field?.toLowerCase() != "channel")) ? "" : "treeselect-row-hidden";
                    }
                })
            }
        })
    }

    changeValeAccordingToDataTypeAndOperator(rule: SavedSearchNS.IRuleList) {
        let selectedDataTypeAndOperator = DataTypeWithOperatorNS.SavedSearchDataTypeWithOperator.find(x => x.DataType == rule.filter.fieldDataType && x.Operator == rule.operator.name);
        rule.dataTypeWithOperator = selectedDataTypeAndOperator;
        this.lastRuleValues.selectedDataTypeWithOperator = selectedDataTypeAndOperator;
        if (selectedDataTypeAndOperator.Operator == 'HasValue') {
            this.lastRuleValues.selectedValue = 'Any';
            this.lastRuleValues.selectedValue2 = null;
            this.lastRuleValues.compareWithField = false;
            this.lastRuleValues.comparisonCriteria = null;
            this.lastRuleValues.comparisonCriteriaLabel = null;
            this.lastRuleValues.comparisonCriteriaParentLabel = null;
            this.lastRuleValues.comparisonCustomAttributeObjectId = null;
        }
        else if (selectedDataTypeAndOperator.Operator == 'NoValue') {
            this.lastRuleValues.selectedValue = ' ';
            this.lastRuleValues.selectedValue2 = null;
            this.lastRuleValues.compareWithField = false;
            this.lastRuleValues.comparisonCriteria = null;
            this.lastRuleValues.comparisonCriteriaLabel = null;
            this.lastRuleValues.comparisonCriteriaParentLabel = null;
            this.lastRuleValues.comparisonCustomAttributeObjectId = null;
        }
        else if (this.selectedEditRule && (rule?.filter?.field?.toLowerCase() == this.selectedEditRule?.filter?.field?.replace(/ /g, '').toLowerCase() || rule?.filter?.field?.toLowerCase() == this.selectedEditRule?.filter?.field?.toLowerCase())) {
            this.lastRuleValues.selectedValue = ((this.selectedEditRule?.value == 'Any' || this.selectedEditRule?.value ==' ') ? null : this.selectedEditRule?.value);
            this.lastRuleValues.selectedValue2 = this.selectedEditRule?.value2 ?? null;

            if(this.selectedEditRule.filter?.fieldDataType == 'DateTime' && this.selectedEditRule?.value !== 'Any'){
                if(this.selectedEditRule.value && this.selectedEditRule.dataTypeWithOperator?.NoOfValuesToBePassed != 'Between_Value' &&
                (this.selectedEditRule.dataTypeWithOperator?.Operator != 'Is' || (this.selectedEditRule.dataTypeWithOperator?.Operator == 'Is' && this.selectedEditRule.value2?.code == 'custom'))){
                    this.lastRuleValues.selectedValue = new Date(this.selectedEditRule.value);
                }

                if(this.selectedEditRule.dataTypeWithOperator?.NoOfValuesToBePassed == 'Between_Value' &&  this.selectedEditRule.value?.length==2){
                    this.lastRuleValues.selectedValue = [new Date(this.selectedEditRule.value[0]),new Date(this.selectedEditRule.value[1])];
                }
            }

            if(this.selectedEditRule.filter?.fieldDataType == 'Time' && this.selectedEditRule?.value !== 'Any'){
                if(this.selectedEditRule.dataTypeWithOperator?.NoOfValuesToBePassed == 'Between_Value' &&  this.selectedEditRule.value?.length==2){
                    this.lastRuleValues.selectedValue = this.selectedEditRule.value[0];
                    this.lastRuleValues.selectedValue2 = this.selectedEditRule.value[1];
                }
            }

            if(this.lastRuleValues.compareWithField){
                this.lastRuleValues.selectedValue = 0;
            }
        }
        else {
            this.lastRuleValues.selectedValue = null;
            this.lastRuleValues.selectedValue2 = null;
            this.lastRuleValues.compareWithField = false;
            this.lastRuleValues.comparisonCriteria = null;
            this.lastRuleValues.comparisonCriteriaLabel = null;
            this.lastRuleValues.comparisonCriteriaParentLabel = null;
            this.lastRuleValues.comparisonCustomAttributeObjectId = null;
        }

        this.onChangeRuleFieldValue(this.lastRuleValues);
    }

    onOperatorChangeRuleList(rule: SavedSearchNS.IRuleList) {
        let selectedDataTypeAndOperator = DataTypeWithOperatorNS.SavedSearchDataTypeWithOperator.find(x => x.DataType == rule.filter.fieldDataType && x.Operator == rule.operator.name);
        rule.dataTypeWithOperator = selectedDataTypeAndOperator;
        this.lastRuleValues.selectedDataTypeWithOperator = selectedDataTypeAndOperator;
        if (selectedDataTypeAndOperator.Operator == 'HasValue') {
            rule.value = 'Any';
            rule.value2 = null;
        }
        else {
            rule.value = null;
            rule.value2 = null;
        }

        rule.compareWithField = false;
        rule.comparisonCriteria = null;
        rule.comparisonCriteriaLabel = null;
        rule.comparisonCriteriaParentLabel = null;
        rule.comparisonCustomAttributeObjectId = null;

        this.onChangeRuleFieldValue(rule);
    }

    onCompareFieldChange(rule: SavedSearchNS.IRuleList) {
        rule['selectedValue'] = 0;
        rule['value'] = 0;
        rule.compareWithField = !!rule.comparisonCriteria as boolean;
        const foundObject = this.availableCompareFields.find(obj => obj?.criteria === rule.comparisonCriteria);
        rule.comparisonCriteriaLabel = foundObject?.labelname||null;
        rule.comparisonCriteriaParentLabel = foundObject?.parentLabelName||null;
        rule.comparisonCustomAttributeObjectId = foundObject?.customAttributeObjectId||null;
        if (foundObject && foundObject?.custom) {
            rule.isCustomComparisonCriteria = true;
        }else{
            rule.isCustomComparisonCriteria = false;
        }
    }

    onOperatorChangeRuleEdit(rule: SavedSearchNS.IRuleList) {
        let selectedDataTypeAndOperator = DataTypeWithOperatorNS.SavedSearchDataTypeWithOperator.find(x => x.DataType == rule.filter.fieldDataType && x.Operator == rule.operator.name);
        rule.dataTypeWithOperator = selectedDataTypeAndOperator;
        this.lastRuleValues.selectedDataTypeWithOperator = selectedDataTypeAndOperator;
        if (selectedDataTypeAndOperator.Operator == 'HasValue') {
            this.lastRuleValues.selectedValue = 'Any';
            this.lastRuleValues.selectedValue2 = null;
        }
        else if (this.selectedEditRule && rule?.filter?.field?.toLowerCase() == this.selectedEditRule?.filter?.field?.toLowerCase()) {
            this.lastRuleValues.selectedValue = this.selectedEditRule?.value ?? null;
            this.lastRuleValues.selectedValue2 = this.selectedEditRule?.value2 ?? null;
        }
        else {
            this.lastRuleValues.selectedValue = null;
            this.lastRuleValues.selectedValue2 = null;
        }
    }

    onOperatorChange(field: SavedSearchNS.IField) {
        // console.log(field);
        let rule: SavedSearchNS.IRuleList = {
            id: 0,
            module: this.isMainModule == true ? this.selectedParentModule : this.selectedAssoModule,
            subModule: this.selectedAssoModule,
            template: this.isMainModule == true ? this.selectedParentTemplate : this.selectedAssoTemplate,
            filter: this.lastRuleValues.selectedFilter,
            operator: this.lastRuleValues.selectedOperator,
            value: this.lastRuleValues.selectedValue,
            value2: this.lastRuleValues.selectedValue2,
            choice: this.lastRuleValues.selectedChoice,
            isMainModule: this.isMainModule,
            dataTypeWithOperator: null,
            valueLists: this.lastRuleValues.allEnumMultiselect,
            treeValueLists: this.lastRuleValues.treeSelectData,
            objectId: this.isMainModule == true ? this.selectedParentModule?.objectId : this.selectedAssoModule?.objectId,
            objectName: this.isMainModule == true ? this.selectedParentModule?.name : this.selectedAssoModule?.name,
            valueRefId: [],
            groupLabel: this.lastRuleValues.selectedGroupLabel,
            groupChildren: this.lastRuleValues.selectedGroupChildren,
            group: this.lastRuleValues.selectedGroup,
            filtersDD: this.lastRuleValues.filtersDD,
            filtersDDTree: this.lastRuleValues.filtersDDTree,
            canEdit: true,
            accountChannel: this.selectedAccountChannel,
            compareWithField: false,
            comparisonCriteria: null,
            comparisonCriteriaLabel: null,
            comparisonCriteriaParentLabel: null,
            isCustomComparisonCriteria: false,
            customAttributeObjectId: this.lastRuleValues.customAttributeObjectId||null,
            comparisonCustomAttributeObjectId: null,
            comparisonCriteriaObject: this.isMainModule == true ? this.selectedParentModule?.name : this.selectedAssoModule?.name,
        }
        this.changeValeAccordingToDataTypeAndOperator(rule);
    }

    onValueChangeRuleList(rule: SavedSearchNS.IRuleList) {
        if (rule.filter?.valueDataType == 'Country') {

        }
    }

    dateTimeOperatorValueChange() {

    }

    //Remove from rule list
    removeList(i: any) {

        //Check removable
        const selectedRule = this.ruleList[i];
        const state = (this.ruleList.find(x => x.filter.field?.toLowerCase() == "state")||(this.lastRuleValues.selectedFilter?.field?.toLowerCase()=="state")) ? true : false;
        const city = (this.ruleList.find(x => x.filter.field?.toLowerCase() == "city")||(this.lastRuleValues.selectedFilter?.field?.toLowerCase()=="city")) ? true : false;

        const trans_location_state = (this.ruleList.find(x => x.filter.field?.toLowerCase() == "trans_location_state")||(this.lastRuleValues.selectedFilter?.field?.toLowerCase()=="trans_location_state")) ? true : false;
        const trans_location_city = (this.ruleList.find(x => x.filter.field?.toLowerCase() == "trans_location_city")||(this.lastRuleValues.selectedFilter?.field?.toLowerCase()=="trans_location_city")) ? true : false;
        
        // billing
        const trans_billing_state = (this.ruleList.find(x => x.filter.field?.toLowerCase() == "trans_billing_state")||(this.lastRuleValues.selectedFilter?.field?.toLowerCase()=="trans_billing_state")) ? true : false;
        const trans_billing_city = (this.ruleList.find(x => x.filter.field?.toLowerCase() == "trans_billing_city")||(this.lastRuleValues.selectedFilter?.field?.toLowerCase()=="trans_billing_city")) ? true : false;

        //
     
        //shipping
        const trans_shipping_state = (this.ruleList.find(x => x.filter.field?.toLowerCase() == "trans_shipping_state")||(this.lastRuleValues.selectedFilter?.field?.toLowerCase()=="trans_shipping_state")) ? true : false;
        const trans_shipping_city = (this.ruleList.find(x => x.filter.field?.toLowerCase() == "trans_shipping_city")||(this.lastRuleValues.selectedFilter?.field?.toLowerCase()=="trans_shipping_city")) ? true : false;
         // address
         const trans_address_state = (this.ruleList.find(x => x.filter.field?.toLowerCase() == "trans_address_state")||(this.lastRuleValues.selectedFilter?.field?.toLowerCase()=="trans_address_state")) ? true : false;
         const trans_address_city = (this.ruleList.find(x => x.filter.field?.toLowerCase() == "trans_address_city")||(this.lastRuleValues.selectedFilter?.field?.toLowerCase()=="trans_address_city")) ? true : false;
         //

        const opportunity_state = (this.ruleList.find(x => x.filter.field?.toLowerCase() == "opportunity_state")||(this.lastRuleValues.selectedFilter?.field?.toLowerCase()=="opportunity_state")) ? true : false;
        const opportunity_city = (this.ruleList.find(x => x.filter.field?.toLowerCase() == "opportunity_city")||(this.lastRuleValues.selectedFilter?.field?.toLowerCase()=="opportunity_city")) ? true : false;

        const associatedChannel = (this.ruleList.find(x => x.filter.field?.toLowerCase() == "associatedchannelname")||(this.lastRuleValues.selectedFilter?.field?.toLowerCase()=="associatedchannelname")) ? true : false;
        const associatedName = (this.ruleList.find(x => x.filter.field?.toLowerCase() == "associationname")||(this.lastRuleValues.selectedFilter?.field?.toLowerCase()=="associationname")) ? true : false;
        const logtype = (this.ruleList.find(x => x.filter.field?.toLowerCase() == "logtype")||(this.lastRuleValues.selectedFilter?.field?.toLowerCase()=="logtype")) ? true : false;
        const logsubtype = (this.ruleList.find(x => x.filter.field?.toLowerCase() == "logsubtype")||(this.lastRuleValues.selectedFilter?.field?.toLowerCase()=="logsubtype")) ? true : false;

        const associatedTaskChannel = (this.ruleList.find(x => x.filter.field?.toLowerCase() == "channel")||(this.lastRuleValues.selectedFilter?.field?.toLowerCase()=="channel")) ? true : false;
        const associatedTaskName = (this.ruleList.find(x => x.filter.field?.toLowerCase() == "association")||(this.lastRuleValues.selectedFilter?.field?.toLowerCase()=="association")) ? true : false;

        const transactionType = this.ruleList.find(x => x.filter.field?.toLowerCase() == "trans_transactiontype");

        if(transactionType){
            const addedTransactionFields = (this.ruleList.find(x => x.objectId == transactionType.objectId));
            if(selectedRule?.filter?.field?.toLowerCase()=='trans_transactiontype' && (addedTransactionFields || this.selectedAssoModule?.name=="Transactions")){
                return; //not removable if dependent field added
            }
        }

        if((selectedRule?.filter?.field?.toLowerCase()=='country' && state)
        || (selectedRule?.filter?.field?.toLowerCase()=='state' && city)
        || (selectedRule?.filter?.field?.toLowerCase()=='trans_location_country' && trans_location_state)
        || (selectedRule?.filter?.field?.toLowerCase()=='trans_location_state' && trans_location_city)
        || (selectedRule?.filter?.field?.toLowerCase()=='opportunity_country' && opportunity_state)
        || (selectedRule?.filter?.field?.toLowerCase()=='opportunity_state' && opportunity_city)
        || (selectedRule?.filter?.field?.toLowerCase()=='associatedmodulename' && associatedChannel)
        || (selectedRule?.filter?.field?.toLowerCase()=='associatedchannelname' && associatedName)
        || (selectedRule?.filter?.field?.toLowerCase()=='relatedto' && associatedTaskChannel)
        || (selectedRule?.filter?.field?.toLowerCase()=='channel' && associatedTaskName)
        || (selectedRule?.filter?.field?.toLowerCase()=='type' && logtype)
        || (selectedRule?.filter?.field?.toLowerCase()=='logtype' && logsubtype
        || (selectedRule?.filter?.field?.toLowerCase()=='trans_billing_country' && trans_billing_state)
        || (selectedRule?.filter?.field?.toLowerCase()=='trans_billing_state' && trans_billing_city)
        || (selectedRule?.filter?.field?.toLowerCase()=='trans_shipping_country' && trans_shipping_state)
        || (selectedRule?.filter?.field?.toLowerCase()=='trans_shipping_state' && trans_shipping_city)
        || (selectedRule?.filter?.field?.toLowerCase()=='trans_address_country' && trans_address_state)
        || (selectedRule?.filter?.field?.toLowerCase()=='trans_address_state' && trans_address_city))
        ){
            return; //not removable if dependent field added
        }

        this.ruleList.splice(i, 1);
        this.setDependentTreeFields(null);
    }

    //#region task SS
    getTaskType(changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList){
        this.setDropDownValue(changeType, this.savedSearchTaskType, rule);
    }

    getTaskAssociation(changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList) {
        this.taskService.getTaskModules().subscribe(
          (types: any) => {
            let resValue = [];
            if (types) {
              // Temporarily remove the filter to check if it's excluding all items
              resValue = types.map(x => ({ id: x.id, name: x.name }));
            }
            this.setDropDownValue(changeType, resValue, rule);
          },
          (error) => {
            console.error('Error fetching task associations:', error);
          }
        );
      }


    getTaskPriority(changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList) {
        forkJoin({
          priority: this.tasksService.filteredPriority(),
        }).subscribe({
          next: (results) => {
            // Map results to the id-name structure and set values for each dropdown
            this.setDropDownValue(changeType, results.priority?.map(priority => ({ id: priority.id, name: priority.name })), rule);
          },
          error: (error) => {
            console.error("Error fetching dropdown values:", error); // Log error for debugging
          }
        });
      }


    getTaskCategories(changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList) {
        this.taskCategoryService.getTaskActiveCategoryGet().subscribe(
            (types: any) => {
                let resValue = [];
                if (types) {
                    types = types.filter(x => x?.statusId == 1);
                    resValue = types.map(x => ({ id: x.id, name: x.name }));
                }
                this.setDropDownValue(changeType, resValue, rule);
            },
            (error) => {
                console.error('Error fetching task categories:', error);
            }
        );
    }

      //for ContactRoles
      
    loadContactRoles(changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList): void {
        this.appMainService.isShowSpinner('contactRoles');
        this.configService.getNewAllContactRoles().subscribe({
        next: (resp: any[]) => {
           let contactRoles :any = resp?.length ? resp : [];
           contactRoles = contactRoles.map(x => ({ id: x.id, name: x.name }));
           this.setDropDownValue(changeType, contactRoles, rule);
           this.appMainService.isHideSpinner("contactRoles");
        },
        error: (err) => {
            this.appMainService.isHideSpinner('contactRoles');
        }
        });
    }

    fetchTaskStatuses(changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList) {
        this.appMainService.isShowSpinner("fetchTaskStatuses");

        this.taskService.getTaskStatuses().then((taskStatuses: TaskStatus[]) => {
          let resValue = [];
          if (taskStatuses) {
            resValue = taskStatuses.map((status: TaskStatus) => ({ id: status.id, name: status.name })); // Map to id-name format
          }
          this.setDropDownValue(changeType, resValue, rule); // Set dropdown values
          this.appMainService.isHideSpinner("fetchTaskStatuses");
        }).catch(() => {
          this.appMainService.isHideSpinner("fetchTaskStatuses"); // Ensure spinner is hidden on error
        });
    }


    
    getAllReturnTypes(changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList) {
        this.appMainService.isShowSpinner("returnTypes");

        this.salesOrderService.getAllReturnTypes().subscribe({
            next: (resp: any) => {
                let resValue = [];
                if (resp) {
                    resValue = resp.map((response) => ({ id: response.id, name: response.name })); 
                }
                this.setDropDownValue(changeType, resValue, rule); 
                this.appMainService.isHideSpinner("returnTypes");
            },
            error: () => {
                this.appMainService.isHideSpinner("returnTypes"); // Ensure spinner is hidden on error
            }
        });
    }

    getAllResons(changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList) {
        this.appMainService.isShowSpinner("reasons");

        this.salesOrderService.getAllReturnReasons().subscribe({
            next: (resp: any) => {
                let resValue = [];
                if (resp) {
                    resValue = resp.map((response) => ({ id: response.id, name: response.name })); 
                }
                this.setDropDownValue(changeType, resValue, rule); 
                this.appMainService.isHideSpinner("reasons");
            },
            error: () => {
                this.appMainService.isHideSpinner("reasons");
            }
        });
    }

    getVendorRMALocation(changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList) {
        this.appMainService.isShowSpinner("reasons");

        this.salesOrderService.getRMALocations().subscribe({
            next: (resp: any) => {
                let resValue = [];
                if (resp) {
                    resValue = resp.map((response) => ({ id: response.id, name: `${response.locationId} - ${response.name}`})); 
                }
                this.setDropDownValue(changeType, resValue, rule); 
                this.appMainService.isHideSpinner("reasons");
            },
            error: () => {
                this.appMainService.isHideSpinner("reasons");
            }
        });
    }

    

    getChanneTasklList(changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList, editedRule: SavedSearchNS.IRuleList) {
        let findSelectedModule = this.ruleList.find((rule, index) => rule.filter?.field?.toLowerCase() == "relatedto");
        if (editedRule || !findSelectedModule) {
            findSelectedModule = this.ruleData.find((rule, index) => rule.filter?.field?.toLowerCase() == "relatedto");
        }

        if (findSelectedModule?.value?.id) {
            const allList = [OpportunityModuleId,ActivityModuleId,VendorModuleId,LocationModuleId,TaskModuleId].includes(findSelectedModule?.value?.id);
            this.sharedChannelService.getChannels(findSelectedModule?.value?.id,allList).subscribe({
                next: (response) => {
                    let resValue = []
                    if (response) {
                        resValue = response.map(x => ({ id: x.id, name: x.name }));
                    }
                    this.setDropDownValue(changeType, resValue, rule, false);
                }
            })
        }
    }

    private getTaskIdList$ = new Subject<void>();

    getTaskIdList(event: any, changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList, querySuggest: boolean = false) {
        this.getTaskIdList$.next();
        this.savedSearchesService.getAllTaskId(SavedSearchTask.TaskId, event?.query || '')
            .pipe(
                takeUntil(this.getTaskIdList$),
                catchError((error) => {
                    console.error('Error fetching task ID list:', error);
                    return of([]);
                })
            )
            .subscribe((response: any) => {
                let list = response.map((task: any) => ({ id: task.id, name: task.taskId }));
                const exist = list.find(obj => obj.name.toLowerCase() === event.query.toLowerCase());

                if (event.query && querySuggest && !exist) {
                    list = [{ id: event.query, name: event.query }, ...list];
                }

                this.setDropDownValue(changeType, list, rule, false);
            });
    }

    private getTaskTitleList$ = new Subject<void>();

    getTaskTitleList(event: any, changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList, querySuggest: boolean = false) {
        this.getTaskTitleList$.next();
        this.savedSearchesService.getAllTaskTitle(SavedSearchTask.TaskTitle, event?.query || '')
            .pipe(
                takeUntil(this.getTaskTitleList$),
                catchError((error) => {
                    console.error('Error fetching task title list:', error);
                    return of([]);
                })
            )
            .subscribe((response: any) => {
                let list = response.map((task: any) => ({ id: task.id || task.taskId, name: task.name }));
                const exist = list.find(obj => obj.name.toLowerCase() === event.query.toLowerCase());

                if (event.query && querySuggest && !exist) {
                    list = [{ id: event.query, name: event.query }, ...list];
                }

                this.setDropDownValue(changeType, list, rule, false);
            });
    }



    //#endregion task SS

    //#region API Calls

    getActivityModules(changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList) {
        let resValue = this.activityModuleList;
        this.setDropDownValue(changeType, resValue, rule);
    }

    getChannelList(changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList, editedRule: SavedSearchNS.IRuleList) {
        let findSelectedModule = this.ruleList.find((rule, index) => rule.filter?.field?.toLowerCase() == "associatedmodulename");
        if (editedRule || !findSelectedModule) {
            findSelectedModule = this.ruleData.find((rule, index) => rule.filter?.field?.toLowerCase() == "associatedmodulename");
        }

        if (findSelectedModule?.value?.id) {
            const allList = [OpportunityModuleId,ActivityModuleId,VendorModuleId,LocationModuleId,TaskModuleId].includes(findSelectedModule?.value?.id);
            this.sharedChannelService.getChannels(findSelectedModule?.value?.id,allList).subscribe({
                next: (response) => {
                    let resValue = []
                    if (response) {
                        resValue = response.map(x => ({ id: x.id, name: x.name }));
                    }
                    this.setDropDownValue(changeType, resValue, rule, false);
                }
            })
        }
    }

    getActivityTypes(changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList) {
        this.logService.getTypesByGroupName("Saved Search Activity Type").then((types: any) => {
            let resValue = [];
            if (types) {
                types = types?.filter(x => x?.statusId == 1);
                resValue = types.map(x => ({ id: x.id, name: x.name }));
            }
            this.setDropDownValue(changeType, resValue, rule);
        });
    }

    getActivityLogTypes(changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList) {
        this.app.logTypesBSubject.subscribe((types) => {
            let resValue = [];
            if (types) {
                types = types?.filter(x => x?.statusId == 1);
                resValue = types.map(x => ({ id: x.id, name: x.name }));
            }
            this.setDropDownValue(changeType, resValue, rule);
        });
    }

    getActivitySubLogTypes(changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList, editedRule: SavedSearchNS.IRuleList) {

        let findSelectedModule = this.ruleList.find((rule, index) => rule.filter?.field?.toLowerCase() == "logtype" && (rule.value?.length>0 && rule.value?.find(l=> ['Mobile','Work'].includes(l?.name))));
        if (editedRule || !findSelectedModule) {
            findSelectedModule = this.ruleData.find((rule, index) => rule.filter?.field?.toLowerCase() == "logtype" && (rule.value?.length>0 && rule.value?.find(l=> ['Mobile','Work'].includes(l?.name))));
        }

        const selectedLogType = findSelectedModule ? findSelectedModule.value?.find(l=> ['Mobile','Work'].includes(l?.name)) : null;

        if(selectedLogType?.id){
            this.logService.getSubLogTypes(selectedLogType?.id).then((types: any) => {
                let resValue = [];
                if (types) {
                    types = types?.filter(x => x?.statusId == 1);
                    resValue = types.map(x => ({ id: x.id, name: x.name }));
                }
                this.setDropDownValue(changeType, resValue, rule);
            });
        }
    }

    getCountryByTemplateId(changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList, editedRule: SavedSearchNS.IRuleList) {
        this.appMainService.isShowSpinner('LoadCountry');
        // // this.ruleService.getCountryByTemplateId(this.selectedParentModule?.id, this.selectedParentTemplate.id).then(res => {
        this.savedSearchesService.getAllCountryDto().subscribe(res => {
            this.appMainService.isHideSpinner('LoadCountry');
            let allCountries = [];
            if (res) {
                allCountries = res.map(x => ({ id: x.id, name: x.name }));
            }
            this.allCountryList = allCountries;
        },
            err => {
                this.appMainService.isHideSpinner('LoadCountry');
            });
    }

    getStatesByCountry(changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList, editedRule: SavedSearchNS.IRuleList, prefix: string = "") {
        // this.currentRuleLists[i].filterOptions = [];
        let findCountrySelected = this.ruleList.find((rule, index) => rule.filter?.field?.toLowerCase() == `${prefix}country`);
        if (editedRule || !findCountrySelected) {
            findCountrySelected = this.ruleData.find((rule, index) => rule.filter?.field?.toLowerCase() == `${prefix}country`);
        }

        if (findCountrySelected?.value?.id) {
            this.appMainService.isShowSpinner('loadStates');
            // this.savedSearchesService.findCountrySelected(this.selectedParentModule?.id, this.selectedParentTemplate.id, findCountrySelected?.value?.id).then(res => {
            this.savedSearchesService.getStateByMultipleCountryIdDto(findCountrySelected?.value?.id?.toString()).pipe(takeUntil(this.ngUnsubscribe$)).subscribe(states => {
                this.appMainService.isHideSpinner('loadStates');
                let allStates = [];
                if (states) {
                    allStates = states.map(x => ({ id: x.id, name: x.name }));
                }
                this.setDropDownValue(changeType, allStates, rule);
            },
                err => {
                    this.appMainService.isHideSpinner('loadStates');
                });
        }
    }

    getCityByStateList(changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList, editedRule: SavedSearchNS.IRuleList, prefix: string = "") {
        this.lastRuleValues.selectedGroupChildren = "cities";
        this.lastRuleValues.selectedGroupLabel = "name";
        this.lastRuleValues.selectedGroup = true;
        let findSelectedStates;
        let findCountrySelected;
        if (editedRule) {
            findSelectedStates = this.ruleData.find((rule, index) => rule.filter?.field?.toLowerCase() == `${prefix}state`);
            findCountrySelected = this.ruleData.find((rule, index) => rule.filter?.field.toLowerCase() == `${prefix}country`);
        }
        else {
            findSelectedStates = this.ruleList.find((rule, index) => rule.filter?.field?.toLowerCase() == `${prefix}state`);
            if (!findSelectedStates) {
                findSelectedStates = this.ruleData.find((rule, index) => rule.filter?.field?.toLowerCase() == `${prefix}state`);
            }
            findCountrySelected = this.ruleList.find((rule, index) => rule.filter?.field.toLowerCase() == `${prefix}country`);
            if (!findCountrySelected) {
                findCountrySelected = this.ruleData.find((rule, index) => rule.filter?.field.toLowerCase() == `${prefix}country`);
            }
        }

        if (findSelectedStates?.value) {
            let stateIds = [];
            for (let ss of findSelectedStates?.value) {
                stateIds.push(ss.id);
            }

            if (stateIds.length > 0) {
                this.appMainService.isShowSpinner('loadCities');
                this.ruleService.getCitiesByStates(0, 0, stateIds.toString(), findCountrySelected?.value?.id).then(citys => {
                    // this.ruleService.getCitiesByStates(this.selectedParentModule?.id, this.selectedAssoTemplate.id, stateIds.toString(), findCountrySelected?.value?.id).then(res => {
                    // this.savedSearchesService.getCitiesByMultipleStateId(stateIds.toString()).pipe(takeUntil(this.ngUnsubscribe$)).subscribe(citys => {
                    this.appMainService.isHideSpinner('loadCities');
                    let allCitys = [];
                    if (citys) {
                        let filterOptions = this.mapToNewArrayCities(citys, 'stateId', 'stateName');
                        // if(filterValue?.length>0){
                        let cities = filterOptions.reduce((acc, curVal) => {
                            return acc.concat(curVal.cities)
                        }, []);
                        // filterValue = findInArray(filterValue, cities);
                        // }
                        allCitys = filterOptions;
                    }
                    this.setDropDownValue(changeType, allCitys, rule);
                },
                    err => {
                        this.appMainService.isHideSpinner('loadCities');
                    });
            }
            else {
                // this.currentRuleLists[i].filterValue = null;
            }

        }
    }

    mapToNewArrayCities(dataSet: any, id = 'id', mapField = 'name') {
        if (dataSet.length) {
            return dataSet.map(obj => ({
                id: Number(obj[id] + ""),
                name: obj[mapField],
                cities: obj.cities ? this.mapToNewArray(obj.cities) : []
            }))
        }
        return [];
    }
    mapToNewArray(dataSet: any, mapField = 'name') {
        if (dataSet.length) {
            return dataSet.map(obj => ({
                id: Number(obj.id + ""),
                name: obj[mapField],
                // count: obj?.count != null ? obj.count : null
            }))
        }
        return [];
    }
    findInArray(filterValArr: any, optionArr: any) {
        return optionArr.filter(obj => filterValArr.find(val => val.name == obj.name));
    }
    setCityGroupValue(field: SavedSearchNS.IField) {
        if (field?.field == 'city') {
            this.lastRuleValues.selectedGroupChildren = "cities";
            this.lastRuleValues.selectedGroupLabel = "name";
            this.lastRuleValues.selectedGroup = true;
        } else {
            this.lastRuleValues.selectedGroupChildren = "";
            this.lastRuleValues.selectedGroupLabel = "";
            this.lastRuleValues.selectedGroup = false;
        }
    }

    getAllLeadTypes(changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList) {
        this.leadService.getAllLeadTypes(TypeGroupIds.LeadTypeLeadAPI).then(types => {
            let resValue = [];
            if (types) {
                types = types?.filter(x => x?.statusId == 1);
                resValue = types.map(x => ({ id: x.id, name: x.name }));
            }
            this.setDropDownValue(changeType, resValue, rule);
        });
    }
    getAllLeadStatus(changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList) {
        this.leadService.getAllLeadStatus(StatusGroupIds.LeadStatusGroupId).then(status => {
            let resValue = []
            if (status) {
                resValue = status.map(x => ({ id: x.id, name: x.name }));
            }
            this.setDropDownValue(changeType, resValue, rule);
        });
    }
    getActiveInactiveStatus(changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList, objectId: number){
        let resValue = SavedSearchActiveInActiveStatus;

        if(objectId==OpportunityModuleId){
            resValue = SavedSearchOpportunityActiveInActiveStatus;
        }

        if(objectId==ContactModuleId){
            resValue = [
                {id: 1, name: 'Active'},
                {id: 2, name: 'InActive'}
            ];
        }

        this.setDropDownValue(changeType, resValue, rule, false);
    }

    getRelationTypes(changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList){
        let resValue = [
            {id: 1, name: 'Parent'},
            {id: 2, name: 'Child'}
        ];
        this.setDropDownValue(changeType, resValue, rule, false);
    }
    //Stage
    getAllStages(changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList, objectId: number, channelId: number) {
        this.ruleService.getStageList(objectId,channelId).pipe(takeUntil(this.ngUnsubscribe$)).subscribe(stages => {
            let resValue = []
            if (stages) {
                resValue = stages.filter(el => el.id && el.id !== -1).map(x => ({ id: x.id, name: x.name }));
            }
            this.setDropDownValue(changeType, resValue, rule, false);
        });
    }

    //Industry
    getAllIndustries(changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList) {
        this.accountService.getAllIndustries().then(industries => {
            let resValue = []
            if (industries) {
                resValue = industries.map(x => ({ id: x.id, name: x.name }));
            }
            this.setDropDownValue(changeType, resValue, rule);
        });
    }
    //AccountSource
    getAllAccountSource(changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList) {
        this.accountService.getAllSources(this.app.user.organizationId).then(source => {
            let resValue = []
            if (source) {
                resValue = source.map(x => ({ id: x.id, name: x.name }));
            }
            this.setDropDownValue(changeType, resValue, rule);
        });
    }
    //Owners
    getAllOwners(changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList) {
        this.accountService.getAllOwnerships().then(owners => {
            let resValue = []
            if (owners) {
                resValue = owners.map(x => ({ id: x.id, name: x.name }));
            }
            this.setDropDownValue(changeType, resValue, rule);
        });
    }
    //LeadSource
    getAllLeadSource(changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList) {
        this.leadService.getAllSources(this.app.user.organizationId).then(source => {
            let resValue = []
            if (source) {
                resValue = source.map(x => ({ id: x.id, name: x.name }));
            }
            this.setDropDownValue(changeType, resValue, rule);
        });
    }
    //Currency
    getCurrencyList(changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList) {
        this.accountService.getCurrency().then(currencyList => {
            let resValue = []
            if (currencyList) {
                resValue = currencyList.map(x => ({ id: x.id, name: `${x.name} - ${x.code}` }));
            }
            this.setDropDownValue(changeType, resValue, rule);
        });
    }
    //Language
    getLanguageList(changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList) {
        this.accountService.getLanguage().then(languageList => {
            let resValue = []
            if (languageList) {
                resValue = languageList.map(x => ({ id: x.id, name: x.name }));
            }
            this.setDropDownValue(changeType, resValue, rule);
        });
    }
    //Timezone
    getAllTimezones(changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList) {
        this.accountService.getTimezone().then(timezoneList => {
            let resValue = []
            if (timezoneList) {
                resValue = timezoneList.map(x => ({ id: x.id, name: x.name }));
            }
            this.setDropDownValue(changeType, resValue, rule);
        });
    }
    //AnnualRevenue
    getAllAnnualRevenue(changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList) {
        this.accountService.getAllRevenues().then(revenue => {
            let resValue = []
            if (revenue) {
                resValue = revenue.map(x => ({ id: x.id, name: x.name }));
            }
            this.setDropDownValue(changeType, resValue, rule);
        });
    }
    //Address Class
    getAccountAddressClass(changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList) {
        this.accountService.getAccountAddressClasses().subscribe(addressClasses => {
            let resValue = addressClasses;
            if (resValue) {
                resValue = resValue.map(x => ({ id: x.id, name: x.name }));
            }
            this.setDropDownValue(changeType, resValue, rule);
        });
    }
    //Address Type
    getAccountAddressTypes(changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList) {
        this.accountService.getAccounAddressTypes().subscribe(addressTypes => {
            let resValue = addressTypes;
            if (resValue) {
                resValue = resValue.map(x => ({ id: x.id, name: x.name }));
            }
            this.setDropDownValue(changeType, resValue, rule);
        });
    }
    //Rating
    getAllRatings(changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList) {
        this.fieldService.getAllRatings().pipe(takeUntil(this.ngUnsubscribe$)).subscribe(ratings => {
            let resValue = ratings || [];
            if (ratings) {
                resValue = ratings.map(x => ({ id: x.id, name: x.name }));
            }
            this.setDropDownValue(changeType, resValue, rule);
        });
    }
    //Salutation/Title
    getSalutations(changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList) {
        this.contactService.getSalutations().pipe(takeUntil(this.ngUnsubscribe$)).subscribe(resp => {
            let resValue = resp.filter(el => el?.isActive === true) || [];
            if (resValue) {
                resValue = resValue.map(x => ({ id: x.id, name: x.name }));
            }
            this.setDropDownValue(changeType, resValue, rule);
        });
    }
    //Genders
    getGenders(changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList) {
        this.contactService.getAllGender().then(resp => {
            let resValue = resp.filter(el => el?.isActive === true) || [];
            if (resValue) {
                resValue = resValue.map(x => ({ id: x.id, name: x.name }));
            }
            this.setDropDownValue(changeType, resValue, rule);
        });
    }
    //EmployeesRange
    getAllEmployeesCount(changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList) {
        this.leadService.getAllEmployeesCount().then(count => {
            let resValue = count.filter(el => el.statusId === 1);
            if (resValue) {
                resValue = resValue.map(x => ({ id: x.id, name: x.name }));
            }
            this.setDropDownValue(changeType, resValue, rule);
        });
    }
    //JobFunction
    getJobFunction(changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList) {
        this.configService.getContactRoles().pipe(takeUntil(this.ngUnsubscribe$)).subscribe(jobFunctions => {
            let resValue = []
            if (jobFunctions) {
                resValue = jobFunctions.map(x => ({ id: x.id, name: x.name }));
            }
            this.setDropDownValue(changeType, resValue, rule);
        });
    }

    getAllCountryTerriList(changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList) {
        if (this.territory?.length == 0) {
            const moduleId = this.selectedParentModule?.objectId||0;
            const templateId = this.selectedParentTemplate?.channelId||0;
            this.appMainService.isShowSpinner('CountryTerriList');
            this.ruleService.getAllTerritoryies(moduleId,templateId,true).pipe(takeUntil(this.ngUnsubscribe$)).subscribe(res => {
                this.appMainService.isHideSpinner('CountryTerriList');
                let terriCountries = res ?? [];
                if (terriCountries) {
                    terriCountries = terriCountries.filter(x => x?.children?.length > 0);
                    const treeData = this.addTerritoryLabel(terriCountries);
                    this.territory = treeData;
                }
            },
                error => {
                    this.appMainService.isHideSpinner('CountryTerriList');
                });
        }

    }

    addTerritoryLabel(originalData) {
        const convertedData = originalData.map((item) => {
            const { children, ...data } = item;
            const childrenData = this.addTerritoryLabel(children);
            return {
                ...data,
                label: data.name,
                children: childrenData,
            };
        });
        return convertedData;
    }

    getAllAccountTypes(changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList) {
        this.ruleService.getAllAccountTypes(AccountGroupId.ID).pipe(takeUntil(this.ngUnsubscribe$)).subscribe(types => {
            let resValue = [];
            if (types) {
                types = types?.filter(x => x?.statusId == 1);
                resValue = types.map(x => ({ id: x.id, name: x.name }));
            }
            this.setDropDownValue(changeType, resValue, rule);
        }, err => {
        });
    }

    getAllTags(changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList) {
        this.ruleService.getAllTags().pipe(takeUntil(this.ngUnsubscribe$)).subscribe(tags => {
            let resValue = [];
            if (tags) {
                tags = tags?.filter(x => x?.statusId == 1);
                resValue = tags.map(x => ({ id: x.id, name: x.name }));
            }
            this.setDropDownValue(changeType, resValue, rule);
        }, err => {
        });
    }

    getTerritoryUsers(changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList){
        this.terriservice.getTerritoryUsers().then(users=>{
            let resValue = [];
            if (users) {
                resValue = users.map(x => ({ id: x.id, name: x.name }));
            }

            this.setDropDownValue(changeType, resValue, rule);
        }).catch(error=>{

        })
    }

    getUserRoles(changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList) {
        this.configService.getOrgRoles(this.app.user.organizationId).pipe(takeUntil(this.ngUnsubscribe$)).subscribe(items => {
            let resValue = []
            if (items) {
                resValue = items.map(x => ({ id: x.roleId, name: x.role.name }));
            }
            this.setDropDownValue(changeType, resValue, rule);
        });
    }

    getUserJobTypes(changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList) {
        this.configService.getJobTypes().pipe(takeUntil(this.ngUnsubscribe$)).subscribe(items => {
            let resValue = []
            if (items) {
                resValue = items.map(x => ({ id: x.id, name: x.name }));
            }
            this.setDropDownValue(changeType, resValue, rule);
        });
    }

    getUserDepartments(changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList) {
        this.configService.getDepartments().pipe(takeUntil(this.ngUnsubscribe$)).subscribe(items => {
            let resValue = []
            if (items) {
                resValue = items.map(x => ({ id: x.id, name: x.name }));
            }
            this.setDropDownValue(changeType, resValue, rule);
        });
    }

    getUserWorkingLocations(changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList) {
        this.configService.getUserWorkingLocation().pipe(takeUntil(this.ngUnsubscribe$)).subscribe(items => {
            let resValue = []
            if (items) {
                resValue = items.map(x => ({ id: x.id, name: x.name }));
            }
            this.setDropDownValue(changeType, resValue, rule);
        });
    }

    //#region ******Estimate Dropdown******
    getAllWarehouse(changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList, name: string = 'name', searchValue: string = "", querySuggest: boolean = false) {
        this.savedSearchesService.getAllWarehouse(searchValue).pipe(takeUntil(this.ngUnsubscribe$)).subscribe(res => {
            let resValue: any[] = [];
            if (res) {
                resValue = res.map(x => ({ id: x.id, name: x[name]||x.name }));
                resValue = resValue?.sort((a, b) => (a.name > b.name) ? 1 : -1) ?? resValue;
            }

            if(searchValue && querySuggest){
                resValue = [...[{id: searchValue, name: searchValue}],...resValue];
            }
            this.setDropDownValue(changeType, resValue, rule, false);
        }, err => {
        });
    }
    getAllLocationTypes(groupId: number, changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList) {
        this.locationService.getAllGroupTypes(groupId).pipe(takeUntil(this.ngUnsubscribe$)).subscribe(res => {
            let resValue = [];
            if (res) {
                resValue = res.map(x => ({ id: x.id, name: x.name }));
            }
            this.setDropDownValue(changeType, resValue, rule);
        }, err => {
        });
    }
    getAllLocationGroups(groupId: number, changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList) {
        this.locationService.getAllGroups(groupId).pipe(takeUntil(this.ngUnsubscribe$)).subscribe(res => {
            let resValue = [];
            if (res) {
                resValue = res.map(x => ({ id: x.id, name: x.name }));
            }
            this.setDropDownValue(changeType, resValue, rule);
        }, err => {
        });
    }
    getAllLocationCategory(groupId: number, changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList) {
        this.locationService.getAllCategory(groupId).pipe(takeUntil(this.ngUnsubscribe$)).subscribe(res => {
            let resValue = [];
            if (res) {
                resValue = res.map(x => ({ id: x.id, name: x.name }));
            }
            this.setDropDownValue(changeType, resValue, rule);
        }, err => {
        });
    }
    getPaymentTermList(changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList) {
        this.paymenttermService.getPaymentTermList().pipe(takeUntil(this.ngUnsubscribe$)).subscribe(res => {
            let resValue = [];
            if (res) {
                resValue = res.map(x => ({ id: x.id, name: x.name }));
            }
            this.setDropDownValue(changeType, resValue, rule);
        }, err => {
        });
    }

    getVendorPaymentTermList(changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList) {
        this.paymenttermService.getPaymentTermList(1, true).subscribe((terms) => {
            const resValue = terms?.filter(term => {
                term.inactive = term.statusId !== 1;
                return term.statusId === 1;
            });

            // Set the dropdown value with filtered terms
            this.setDropDownValue(changeType, resValue, rule);
        });
    }

    getPaymentMrthodList(changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList) {
        this.paymentmethodService.getPaymentMrthodList().pipe(takeUntil(this.ngUnsubscribe$)).subscribe(res => {
            let resValue = [];
            if (res) {
                resValue = res.map(x => ({ id: x.id, name: x.name }));
            }
            this.setDropDownValue(changeType, resValue, rule);
        }, err => {
        });
    }

    getVendorPaymentMethodList(changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList) {
        this.paymentmethodService.getPaymentMrthodList(3, true).subscribe((methods) => {
            const resValue = methods?.filter(method => {
                method.inactive = method.statusId !== 1;
                return method.statusId === 1;
            })

            this.setDropDownValue(changeType, resValue, rule);
        });
    }

    getShippingTermList(changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList) {
        this.shippingtermService.getShippingTermList().pipe(takeUntil(this.ngUnsubscribe$)).subscribe(res => {
            let resValue = [];
            if (res) {
                resValue = res.map(x => ({ id: x.id, name: x.name }));
            }
            this.setDropDownValue(changeType, resValue, rule);
        }, err => {
        });
    }
    getShippingMethodList(changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList) {
        this.shippingmethodService.getShippingMethodList().pipe(takeUntil(this.ngUnsubscribe$)).subscribe(res => {
            let resValue = [];
            if (res) {
                resValue = res.map(x => ({ id: x.id, name: x.name }));
            }
            const treeList = this.utilityService.prepareShippingMethods(res);
            this.lastRuleValues.treeSelectData = treeList;

            if (rule) {
                const selectedValues = [];
                rule.value?.map(value=>{
                    const addedList: any = this.utilityService.findShippingMethodById(this.lastRuleValues.treeSelectData, value?.id);
                    if(addedList)selectedValues.push(addedList);
                })

                this.lastRuleValues.selectedValue = selectedValues;
            }

            // this.setDropDownValue(changeType, resValue, rule);
        }, err => {
        });
    }

    getConfigData(type, moduleName, changeType, rule) {
        this.savedSearchesService.getConfigurationsByModule(moduleName).pipe(takeUntil(this.ngUnsubscribe$)).subscribe(config => {
            //Product Channels
            const productChannel = config.filter(config => config.name == 'Product Type')[0];
            const producttypes = JSON.parse(productChannel.configurationDetails[0].configJSONValue);
            let channels = producttypes.map(x => ({ id: x.id, name: x.name }));
            if (this.selectedParentModule?.objectId === VendorModuleId) {
                channels = producttypes
                    .filter(x =>
                        x.name !== "Bundle Item" &&
                        x.name !== "Kit/Package Items" &&
                        x.name !== "Finished Goods"
                    )
                    .map(x => ({ id: x.id, name: x.name })); // Map after filtering
            }
            this.setDropDownValue(changeType, channels, rule);
        }, err => {
        });
    }

    getBrandList(changeType, rule) {
        this.savedSearchesService.getBrandList().subscribe((brands) => {
            if (brands) {
                brands = brands.map(x => ({ id: x.id, name: x.name }));
                this.setDropDownValue(changeType, brands, rule);
            }
        });
    }

    getVendor(type, changeType, rule, searchValue: string = "", querySuggest: boolean = false) {
        this.savedSearchesService.getvendorsDD(searchValue).subscribe((vendor) => {
            const preferredVendor = (vendor?.filter(v => v.typeName?.includes('Manufacturer')));
            let list: any[] = [];
            if (type == 'vendor') {
                list = vendor.map(x => ({ id: x.id, name: x.name }));
            } else {
                list = preferredVendor.map(x => ({ id: x.id, name: x.name }));
            }
            list = list?.sort((a, b) => (a.name > b.name) ? 1 : -1) ?? list;
            if(searchValue && querySuggest){
                vendor = [...[{id: searchValue, name: searchValue}],...vendor];
            }
            this.setDropDownValue(changeType, list, rule, false);
        });
    }
    //VendorAddressType
    getVendorAddressType(changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList){
        let resValue = [];
        this.purchaseService.getAddressTypes().subscribe((types) => {
             resValue = types;
             this.setDropDownValue(changeType, resValue, rule);
          });
    }

    getVendorTypes(groupId: number, changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList) {
        this.locationService.getAllGroupTypes(groupId).pipe(takeUntil(this.ngUnsubscribe$)).subscribe(res => {
            let resValue = [];
            if (res) {
                resValue = res.map(x => ({ id: x.id, name: x.name }));
            }
            this.setDropDownValue(changeType, resValue, rule);
        }, err => {
        });
    }

    getVendorBusinessClassification(groupId: number, changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList) {
        this.locationService.getAllGroupTypes(groupId).pipe(takeUntil(this.ngUnsubscribe$)).subscribe(res => {
            let resValue = [];
            if (res) {
                resValue = res.map(x => ({ id: x.id, name: x.name }));
            }
            this.setDropDownValue(changeType, resValue, rule);
        }, err => {
        });
    }

    getInventoryGroup(type, changeType, rule) {
        this.savedSearchesService.getInventoryGroups().pipe(takeUntil(this.ngUnsubscribe$)).subscribe(res => {
            if (res?.length) {
                const inventoryGroups = res;
                if (type == 'discount') {
                    const taxGroup = inventoryGroups?.filter(grp => grp.name == 'Discount Type')[0];
                    this.getDiscountTypes(taxGroup?.id, changeType, rule);
                } else if (type == 'variant') {
                    const variantGroup = inventoryGroups?.filter(grp => grp.name == 'Product Group')[0];
                    this.getAllProductVariant(variantGroup?.id, changeType, rule);
                } else if (type == 'height' || type == 'weight') {
                    const uomGroup = inventoryGroups?.filter(grp => grp.name == 'UnitOfMeasure')[0];
                    this.getAllUOM(type, uomGroup?.id, changeType, rule);
                } else if (type == 'category') {
                    const categoryGroup = inventoryGroups?.filter(grp => grp.name == 'Product Category')[0];
                    this.getProductCategory(categoryGroup?.id, changeType, rule)
                } else if (['trans_location_type','locationtype'].includes(type)) {
                    const categoryGroup = inventoryGroups?.filter(grp => grp.name == InventoryObjectNames.warehouseConstants.typeGroupName)[0];
                    this.getAllLocationTypes(categoryGroup?.id, changeType, rule)
                } else if (['trans_location_group','locationgroup'].includes(type)) {
                    const categoryGroup = inventoryGroups?.filter(grp => grp.name == InventoryObjectNames.warehouseConstants.groupName)[0];
                    this.getAllLocationGroups(categoryGroup?.id, changeType, rule)
                } else if (['trans_location_category','locationcategory'].includes(type)) {
                    const categoryGroup = inventoryGroups?.filter(grp => grp.name == InventoryObjectNames.warehouseConstants.categoryGroupName)[0];
                    this.getAllLocationCategory(categoryGroup?.id, changeType, rule)
                } else if (type == 'vendortype') {
                    const categoryGroup = inventoryGroups?.filter(grp => grp.name == 'Vendor Type')[0];
                    this.getVendorTypes(categoryGroup?.id, changeType, rule)
                } else if (type == 'businessclassification') {
                    const categoryGroup = inventoryGroups?.filter(grp => grp.name == 'Account Category')[0];
                    this.getVendorBusinessClassification(categoryGroup?.id, changeType, rule)
                }
            }
        }, err => {
        });
    }

    loadAllFinancialAccounts(type, changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList) {
        this.productsService.getAllFinancialAccounts().subscribe(accounts => {
            let data = []
            for (let c of accounts) {
                let ChildData = [];
                for (let s of c.childAccounts) {
                    let subData = [];
                    for (let subb of s.childAccounts) {
                        let childSubbData = [];
                        for(let subChild of subb.childAccounts){
                            if (subChild.statusId == 1) {
                                let eachSubChild: any = {
                                    label: subChild.name,
                                    value: subChild,
                                    children: [],
                                };
                                childSubbData.push(eachSubChild);
                            }
                        }
                        if (subb.statusId == 1) {
                            let eachSub = {
                                label: subb.name,
                                value: subb,
                                children: childSubbData,
                            };
                            subData.push(eachSub);
                        }
                    }
                    if (s.statusId == 1) {
                        let eachSub = {
                            label: s.name,
                            value: s,
                            children: subData
                        }
                        ChildData.push(eachSub)
                    }
                }
                if (c.statusId == 1) {
                    let eachData = {
                        label: c.name,
                        value: c,
                        children: ChildData
                    }
                    data.push(eachData)
                }
            }
            const financialAccounts = data;
            if (type != 'Chart of Accounts') {
                this.lastRuleValues.treeSelectData = financialAccounts?.filter(
                    (acc) => acc.label == type
                );
            } else {
                this.lastRuleValues.treeSelectData = financialAccounts;
            }
            if (rule && rule.value != 'Any' && rule.value != ' ') {
                this.getSavedFinancialAccount(this.lastRuleValues.treeSelectData, rule.value)
            }
        })
    }

    getAllClass(changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList) {
        this.productsService.getClasses().subscribe((cls) => {
            let data = []
            for (let c of cls) {
                let ChildData = [];
                for (let s of c.childClass) {
                    let subData = [];
                    for (let subb of s.childClass) {
                        let childSubbData = [];
                        if (subb.statusId == 1) {
                            let eachSub = {
                                label: subb.name,
                                value: subb,
                                children: childSubbData,
                            };
                            subData.push(eachSub);
                        }
                    }
                    if (s.statusId == 1) {
                        let eachSub = {
                            label: s.name,
                            value: s,
                            children: subData
                        }
                        ChildData.push(eachSub)
                    }
                }
                if (c.statusId == 1) {
                    let eachData = {
                        label: c.name,
                        value: c,
                        children: ChildData
                    }
                    data.push(eachData)
                }
            }
            this.lastRuleValues.treeSelectData = data;
            if (rule) {
                this.getSavedFinancialAccount(this.lastRuleValues.treeSelectData, rule.value)
            }
        });
    }

    getUnitOfMeasures(changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList) {
        this.productsService.getAllMeasurements().subscribe((units) => {
            let data = []
            for (let c of units) {
                let ChildData = [];
                for (let s of c.childUOM) {
                    let subData = [];
                    for (let subb of s.childUOM) {
                        let childSubbData = [];
                        if (subb.statusId == 1) {
                            let eachSub = {
                                label: subb.name,
                                value: subb,
                                children: childSubbData,
                            };
                            subData.push(eachSub);
                        }
                    }
                    if (s.statusId == 1) {
                        let eachSub = {
                            label: s.name,
                            value: s,
                            children: subData
                        }
                        ChildData.push(eachSub)
                    }
                }
                if (c.statusId == 1) {
                    let eachData = {
                        label: c.name,
                        value: c,
                        children: ChildData
                    }
                    data.push(eachData)
                }
            }
            this.lastRuleValues.treeSelectData = data;
            if (rule) {
                this.getSavedFinancialAccount(this.lastRuleValues.treeSelectData, rule.value)
            }
        });
    }

    getProductCategory(productcatId, changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList) {
        this.productsService
            .getAllProductCategoryList(productcatId)
            .subscribe((cat) => {
                // Category Tree
                let cateData = [];
                for (let children of cat) {
                    let childrenData = [];
                    for (let sub of children.childCategory) {

                        let subData = [];
                        for (let subb of sub.childCategory) {
                            let childSubbData = [];
                            for (let childsubb of subb.childCategory) {
                                if (childsubb.statusId == 1) {
                                    let eachSubb = {
                                        label: childsubb.name,
                                        value: childsubb,
                                        children: [],
                                    };
                                    childSubbData.push(eachSubb);
                                }
                            }
                            if (subb.statusId == 1) {
                                let eachSub = {
                                    label: subb.name,
                                    value: subb,
                                    children: childSubbData,
                                };
                                subData.push(eachSub);
                            }
                        }

                        if (sub.statusId == 1) {
                            let eachChildItem = {
                                label: sub.name,
                                value: sub,
                                children: subData,
                            };
                            childrenData.push(eachChildItem);
                        }
                    }

                    if (children.statusId == 1) {
                        let eachItem = {
                            label: children.name,
                            value: children,
                            children: childrenData,
                        };
                        cateData.push(eachItem);
                    }
                }
                this.lastRuleValues.treeSelectData = cateData;
                if (rule) {
                    this.getSavedFinancialAccount(this.lastRuleValues.treeSelectData, rule.value)
                }
            });
    }

    getDiscountTypes(groupId, changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList) {
        this.savedSearchesService.getDiscountTypes(groupId).pipe(takeUntil(this.ngUnsubscribe$)).subscribe(res => {
            res = res.map(x => ({ id: x.id, name: x.name }));
            this.setDropDownValue(changeType, res, rule);
        }, err => {
        });
    }

    getDiscounts(changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList) {
        this.savedSearchesService.getDiscounts(false).pipe(takeUntil(this.ngUnsubscribe$)).subscribe(res => {
            res = res.map(x => ({ id: x.id, name: x.name }));
            this.setDropDownValue(changeType, res, rule);
        }, err => {
        });
    }

    getHandlingFees(changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList) {
        this.salesOrderService.getAdditionalFees().pipe(takeUntil(this.ngUnsubscribe$)).subscribe(res => {
            res = res.map(x => ({ id: x.id, name: x.name }));
            this.setDropDownValue(changeType, res, rule);
        }, err => {
        });
    }

    getTaxList(changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList){
        this.savedSearchesService.getAllList().pipe(takeUntil(this.ngUnsubscribe$)).subscribe(res => {
            res = res.map(x => ({ id: x.id, name: x.name }));
            this.setDropDownValue(changeType, res, rule);
        }, err => {
        });
    }

    getAllProductVariant(groupId, changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList) {
        this.productsService.getInventoryVariantGroups(groupId).pipe(takeUntil(this.ngUnsubscribe$)).subscribe(res => {
            if (res) {
                res = res.map(x => ({ id: x.id, name: x.name }));
                res = res.map(x => ({ id: x.id, name: x.name }));
                this.setDropDownValue(changeType, res, rule);
            }
        }, err => {
        });
    }

    getAllUOM(type, groupId, changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList) {
        this.savedSearchesService.getInventoryCategory(groupId).pipe(takeUntil(this.ngUnsubscribe$)).subscribe(types => {
            if (type == 'height') {
                const heightType = types.filter((s) => s.name == 'Length')[0];
                this.getUOMByCategory(heightType?.id, changeType, rule);
            } else {
                const weightType = types.filter((s) => s.name == 'Weight')[0];
                this.getUOMByCategory(weightType?.id, changeType, rule);
            }
        }, err => {
        });
    }

    getUOMByCategory(categoryId, changeType, rule) {
        this.savedSearchesService.getUOMByCategory(categoryId).pipe(takeUntil(this.ngUnsubscribe$)).subscribe(types => {
            types = types.map(x => ({ id: x.id, name: x.name }));
            this.setDropDownValue(changeType, types, rule);
        }, err => {
        });
    }

    searchAllProductAutoComplateData(event: any, changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList, field) {

        let fieldName = field?.toLowerCase();

        if(fieldName=='trans_item_product_itemno' || (this.selectedParentModule?.objectId==OpportunityModuleId && fieldName=='productname') || (this.selectedAssoModule?.objectId==OpportunityModuleId && fieldName=='opportunity_item_itemno')){
            fieldName = 'itemno';
        }

        switch(fieldName){
            case 'trans_item_product_vendorsku':
                fieldName = 'vendorsku';
                break;
            case 'serialnobarcode':
                fieldName = 'vendorsku';
                break;
        }

            this.savedSearchesService.getAllAutoCompleteData(0, fieldName, event.query)
            .subscribe(data => {
                data = data||[];
                data.map(item=> {
                    item['id'] = item?.id||item?.item1;
                });
                this.setDropDownValue(changeType, data, rule);
            });
    }

    getAccountList(changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList, editedRule: SavedSearchNS.IRuleList) {
        if (editedRule) {
            if (this.lastRuleValues.allEnumMultiselect && editedRule.value) {
                this.lastRuleValues.allEnumMultiselect.push(...editedRule.value);
            }
        }
    }
    getProductMinified(changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList) {
        this.savedSearchesService.getProductMinified().pipe(takeUntil(this.ngUnsubscribe$)).subscribe(res => {
            let resValue = [];
            if (res) {
                resValue = res?.map(x => ({ id: x.id, name: x.name }));
            }
            this.setDropDownValue(changeType, resValue, rule);
        }, err => {
        });
    }
    getOpportunitySources(changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList) {
        this.savedSearchesService.getOpportunitySources(this.app.user.organizationId).pipe(takeUntil(this.ngUnsubscribe$)).subscribe(res => {
            let resValue = [];
            if (res) {
                resValue = res?.map(x => ({ id: x.id, name: x.name }));
            }
            this.setDropDownValue(changeType, resValue, rule);
        }, err => {
        });
    }
    getOpportunityRatings(changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList) {
        this.savedSearchesService.getOpportunityRatings().pipe(takeUntil(this.ngUnsubscribe$)).subscribe(res => {
            let resValue = [];
            if (res) {
                resValue = res?.map(x => ({ id: x.id, name: x.name }));
            }
            this.setDropDownValue(changeType, resValue, rule);
        }, err => {
        });
    }
    getForecastCategories(changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList) {
        this.savedSearchesService.getForecastCategories().pipe(takeUntil(this.ngUnsubscribe$)).subscribe(res => {
            let resValue = [];
            if (res) {
                res = res.filter(x=> x.statusId==Status.Active);
                resValue = res?.map(x => ({ id: x.id, name: x.name }));
            }
            this.setDropDownValue(changeType, resValue, rule);
        }, err => {
        });
    }
    getTransactionTypes(changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList, selectedField:any) {
        let transactionTypeMapping: Map<string, any>;

        if(selectedField=='trans_prod_transaction_action'){
            transactionTypeMapping = new Map<string, any>([
                ["Transactions", TransactionTypes],
                ["VendorTransaction", VendorTransactionTypes],
                ['ProductTransaction',ProductTransactionAction]
            ]);
        }
        else{
             transactionTypeMapping = new Map<string, any>([
                ["Transactions", TransactionTypes],
                ["VendorTransaction", VendorTransactionTypes],
                ['ProductTransaction',ProductTransactionStatus]
            ]);
        }
       
        const transactionTypeValue = transactionTypeMapping.get(this.selectedAssoModule?.name) || null;
        this.setDropDownValue(changeType, transactionTypeValue, rule, false);
    }
    getEstimateStatus(changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList) {
        this.setDropDownValue(changeType, EstimateNewStatusObjects, rule);
    }
    getOrderStatus(changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList) {
        this.setDropDownValue(changeType, OrderStatusObjects, rule);
    }
    getPaymentStatus(changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList) {
        this.setDropDownValue(changeType, InvoicePaymentStatusEnumObjects, rule);
    }
    getShipmentStatus(changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList) {
        this.setDropDownValue(changeType, ShipmentStatusObjects, rule);
    }
    getSalesOrderStatus(changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList) {
        this.setDropDownValue(changeType, SalesOrderStatusEnumObjects, rule);
    }
    getSalesOrderStage(changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList) {
        this.setDropDownValue(changeType, SalesOrderStageEnumObjects, rule);
    }
    getTaxablePreference(changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList) {
        this.setDropDownValue(changeType, TaxPreferenceObjects, rule);
    }

    // Search
    searchAutocompleteItems(event: any, changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList, selectedFilter: SavedSearchNS.IField, querySuggest: boolean = false) {
        let channelId = this.selectedAccountChannel?.id||0;

        if([AccountModuleId,LeadModuleId].includes(this.selectedParentModule.objectId)){
            channelId = this.selectedParentTemplate?.id;
        }
        if(this.selectedParentModule.objectId==LeadModuleId && selectedFilter?.field?.toLowerCase()=='businessname'){
            this.searchAllLeads(event,changeType,rule,channelId,'businessName',querySuggest);
        }else if((selectedFilter?.field?.toLowerCase() == 'name' && selectedFilter?.mapObject?.toLowerCase() == 'opportunity')){
            this.searchAllOpportunities(event, changeType, rule, 0, querySuggest);
        }else if(selectedFilter?.field?.toLowerCase() == 'associationname'){
            this.activityAssociateNames(event, changeType, rule, querySuggest);
        }else if(selectedFilter?.field?.toLowerCase() == 'association') {
            this.taskAssociateNames(event, changeType, rule, querySuggest);
        }else if(selectedFilter?.field?.toLowerCase() == 'taskid') {
            this.getTaskIdList(event, changeType, rule, querySuggest);
        }else if(selectedFilter?.field?.toLowerCase() == 'name') {
            this.getTaskTitleList(event, changeType, rule, querySuggest);
        }else if(['vendor','vendorname','trans_prod_vendor'].includes(selectedFilter?.field?.toLowerCase())){
            this.getVendor('vendor',changeType,rule,event.query || '',querySuggest);
        }else if(selectedFilter?.field?.toLowerCase() == 'locationname'){
            this.getAllWarehouse(changeType,rule,'name',event.query || '',querySuggest);
        }else if(selectedFilter?.field?.toLowerCase() == 'trans_item_product_itemno'){
            this.searchAllItemNo(event,changeType,rule,selectedFilter.field)
        }else{
            this.searchAllAccountsWithSN(event,changeType,rule,channelId,'businessName',querySuggest);
        }
    }

    searchAllAccountsWithSN(event: any, changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList, channelId: number = 0, label: 'nameWithSequenceNumber'|'businessName' = 'nameWithSequenceNumber', querySuggest: boolean = false){

        const requestModel: GelAllAccountRequestModel = {
            channelId: channelId||this.selectedParentTemplate?.id,
            stageId: null,
            isActive: true,
            globalSearchValue: event.query || '',
            includeChildAccounts: true,
            selectableColumns: [
                {columnName: "sequenceNumber", isCustom: false},
                {columnName: "businessName", isCustom: false},
                {columnName: "nameWithSequenceNumber",isCUstom: false}
            ],
            filter: null,
            pageSize: 200,
            pageNumber: 1,
            sortByColumn: "",
            isSortByDescending: false,
            filterInColumns: []
        }

        this.accountServiceN.getAccountsListWithFilters(requestModel).subscribe({
                next: (response) => {
                    if (response) {
                        let list = response?.list ? response?.list.map(account=> ({id: account.id, name: account[label]}))||[] : [];
                        const exist = list.find(obj=> obj.name.toLowerCase() ==event.query.toLowerCase());
                        if(event.query && querySuggest && !exist){
                            list = [...[{id: event.query, name: event.query}],...list];
                        }
                        this.setDropDownValue(changeType, list, rule, false);
                    }
                }
            })
    }

    searchAllLeads(event: any, changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList, channelId: number = 0, label: 'nameWithSequenceNumber'|'businessName' = 'nameWithSequenceNumber', querySuggest: boolean = false){

        const requestModel: GetAllLeadRequestModel = {
            channelId: channelId||this.selectedParentTemplate?.id,
            stageId: 0,
            isActive: true,
            globalSearchValue: event.query || '',
            selectableColumns: [
                {columnName: "sequenceNumber", isCustom: false},
                {columnName: "businessName", isCustom: false},
                {columnName: "nameWithSequenceNumber",isCUstom: false}
            ],
            filter: '',
            pageSize: 200,
            pageNumber: 1,
            sortByColumn: "",
            isSortByDescending: false,
            filterInColumns: []
        }

        this.leadServiceN.getLeadListWithFilters(requestModel).subscribe({
                next: (response) => {
                    if (response) {
                        let list =  response?.list ? response?.list.map(lead=> ({id: lead.id, name: lead[label]}))||[] : [];
                        const exist = list.find(obj=> obj.name.toLowerCase() ==event.query.toLowerCase());
                        if(event.query && querySuggest && !exist){
                            list = [...[{id: event.query, name: event.query}],...list];
                        }
                        this.setDropDownValue(changeType, list, rule, false);
                    }
                }
            })
    }

    searchAllOpportunities(event: any, changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList, channelId: number = 0, querySuggest: boolean = false){

        const requestModel: GelAllOpportunityRequestModel = {
            channelId: channelId||this.selectedParentTemplate?.id,
            accountChannelId: this.selectedAccountChannel?.id||null,
            stageId: null,
            isActive: true,
            globalSearchValue: event.query || '',
            selectableColumns: [
                {columnName: "sequenceNumber", isCustom: false},
                {columnName: "name", isCustom: false},
                {columnName: "nameWithSequenceNumber",isCUstom: false}
            ],
            filter: '',
            pageSize: 200,
            pageNumber: 1,
            sortByColumn: "",
            isSortByDescending: false,
            filterInColumns: []
        }

        this.opportunityService.getAllOpportunities(requestModel).subscribe({
                next: (response) => {
                    if (response) {
                        let list =  response?.list ? response?.list.map(opportunity=> ({id: opportunity.id, name: opportunity.name}))||[] : [];
                        const exist = list.find(obj=> obj.name.toLowerCase() ==event.query.toLowerCase());
                        if(event.query && querySuggest && !exist){
                            list = [...[{id: event.query, name: event.query}],...list];
                        }
                        this.setDropDownValue(changeType, list, rule, false);
                    }
                }
            })
    }

    searchAllCases(event: any, changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList, channelId: number = 0, querySuggest: boolean = false){

        const requestModel: GelAllCasesRequestModel = {
            channelId: channelId||this.selectedParentTemplate?.id,
            accountChannelId: this.selectedAccountChannel?.id||null,
            stageId: null,
            isActive: true,
            globalSearchValue: event.query || '',
            selectableColumns: [
                {columnName: "sequenceNumber", isCustom: false}
            ],
            filter: '',
            pageSize: 200,
            pageNumber: 1,
            sortByColumn: "",
            isSortByDescending: false,
            filterInColumns: []
        }

        this.casesService.getCasesListWithFilters(requestModel).subscribe({
                next: (response) => {
                    if (response) {
                        let list =  response?.list ? response?.list.map(cases=> ({id: cases.id, name: cases.sequenceNumber}))||[] : [];
                        const exist = list.find(obj=> obj.name.toLowerCase() ==event.query.toLowerCase());
                        if(event.query && querySuggest && !exist){
                            list = [...[{id: event.query, name: event.query}],...list];
                        }
                        this.setDropDownValue(changeType, list, rule, false);
                    }
                }
            })
    }

    searchAllItemNo(event: any, changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList, field){
        let fieldName = field?.toLowerCase();

        if(fieldName=='trans_item_product_itemno'){
            fieldName = 'itemno';
        }

            this.savedSearchesService.getAllAutoCompleteData(0, fieldName, event.query)
            .subscribe(data => {
                let list = (data || []).map(item => ({
                    id: item?.id || item?.item1,
                    name: item?.item2,
                    label: item?.item2 + item?.item3,
                }));

                const exist = list.find(obj => obj.name.toLowerCase() === event?.query?.toLowerCase());

                if (event.query  && !exist) {
                    list = [...[{ id: event.query, name: event.query, label: event.query }], ...list];
                }
                this.setDropDownValue(changeType, list, rule);
            });
    }

    activityAssociateNames(event: any, changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList, querySuggest: boolean = false) {

        const associatedModule = this.ruleList.find(x => x.filter.field?.toLowerCase() == "associatedmodulename" && x.operator?.name=="IsEqualTo");
        const associatedModuleData = this.ruleData.find(x => x.filter.field?.toLowerCase() == "associatedmodulename" && x.operator?.name=="IsEqualTo");
        const selectedAssociatedModule = associatedModule||associatedModuleData;

        const associatedChannel = this.ruleList.find(x => x.filter.field?.toLowerCase() == "associatedchannelname" && x.operator?.name=="IsEqualTo");
        const associatedChannelData = this.ruleData.find(x => x.filter.field?.toLowerCase() == "associatedchannelname" && x.operator?.name=="IsEqualTo");
        const selectedAssociatedChannel = associatedChannel||associatedChannelData;



        if(selectedAssociatedModule?.value?.id && selectedAssociatedChannel?.value?.id){
            switch (selectedAssociatedModule?.value?.id) {
                case AccountModuleId:
                    this.searchAllAccountsWithSN(event,changeType,rule,selectedAssociatedChannel.value?.id,'nameWithSequenceNumber',querySuggest);
                    break;
                case LeadModuleId:
                    this.searchAllLeads(event,changeType,rule,selectedAssociatedChannel.value?.id,'nameWithSequenceNumber',querySuggest);
                    break;
                case OpportunityModuleId:
                    this.searchAllOpportunities(event,changeType,rule,selectedAssociatedChannel.value?.id,querySuggest);
                    break;
                default:
                    break;
            }

        }
    }

    //#region task Association

    taskAssociateNames(event: any, changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList, querySuggest: boolean = false) {

        const associatedTaskModule = this.ruleList.find(x => x.filter.field?.toLowerCase() == "relatedto" && x.operator?.name=="IsEqualTo");
        const associatedTaskModuleData = this.ruleData.find(x => x.filter.field?.toLowerCase() == "relatedto" && x.operator?.name=="IsEqualTo");
        const associatedTaskModuleSelcted = associatedTaskModule||associatedTaskModuleData;


        const associatedTaskChannel = this.ruleList.find(x => x.filter.field?.toLowerCase() == "channel" && x.operator?.name=="IsEqualTo");
        const associatedTaskChannelData = this.ruleData.find(x => x.filter.field?.toLowerCase() == "channel" && x.operator?.name=="IsEqualTo");
        const associatedTaskChannelSelected = associatedTaskChannel || associatedTaskChannelData;



        if(associatedTaskModuleSelcted?.value?.id && associatedTaskChannelSelected?.value?.id){
            switch (associatedTaskModuleSelcted?.value?.id) {
                case AccountModuleId:
                    this.searchAllAccountsWithSN(event,changeType,rule,associatedTaskChannelSelected.value?.id,'nameWithSequenceNumber',querySuggest);
                    break;
                case LeadModuleId:
                    this.searchAllLeads(event,changeType,rule,associatedTaskChannelSelected.value?.id,'nameWithSequenceNumber',querySuggest);
                    break;
                case OpportunityModuleId:
                    this.searchAllOpportunities(event,changeType,rule,associatedTaskChannelSelected.value?.id,querySuggest);
                    break;
                case CaseModuleId:
                    this.searchAllCases(event,changeType,rule,associatedTaskChannelSelected.value?.id,querySuggest);
                    break;
                default:
                    break;
            }

        }
    }

    getSavedFinancialAccount(list, savedParam) {
        // console.log(list, savedParam)
        const filteredCategories = [];
        savedParam.forEach((element) => {
            const cat = list.filter(
                (cat) => cat.value?.id == element.id
            )[0];
            if (cat) {
                filteredCategories.push(cat);
            }
        });
        savedParam.forEach((element) => {
            list.forEach((cat) => {
                const childCat = cat.children.filter(
                    (child) => child.value?.id == element.id
                )[0];
                if (childCat) {
                    filteredCategories.push(childCat);
                }
            });
        });
        savedParam.forEach((element) => {
            list.forEach((cat) => {
                cat.children.forEach((childCat) => {
                    const subChildCat = childCat.children.filter(
                        (child) => child.value?.id == element.id
                    )[0];
                    if (subChildCat) {
                        filteredCategories.push(subChildCat);
                    }
                });
            });
        });
        savedParam.forEach((element) => {
            list.forEach((cat) => {
                cat.children.forEach((childCat) => {
                    childCat.children.forEach((childSub) => {
                        const childSubChildCat = childSub.children.filter(
                            (child) => child.value?.id == element.id
                        )[0];
                        if (childSubChildCat) {
                            filteredCategories.push(childSubChildCat);
                        }
                    });
                });
            });
        });
        // console.log(filteredCategories)
        this.lastRuleValues.selectedValue = filteredCategories

    }
    //#endregion

    onChangeAssign(event: any) {
        if (event?.node?.hasChildTerritorys) {
            //this.getTerritory(event?.node);
        }
    }
    onNodeExpand(event: any) {
        // console.log(this.lastRuleValues.selectedValue, event);
        if (event?.node?.hasChildTerritorys) {
            //this.getTerritory(event);
        }
    }

    setDropDownValue(changeType: 'Selected' | 'List', dropDownValue: any, rule: SavedSearchNS.IRuleList, sorting: boolean = true) {
        if (changeType == 'Selected') {
            //sort
            if(sorting){
                dropDownValue = dropDownValue?.sort((a, b) => (a.name > b.name) ? 1 : -1) ?? dropDownValue;
            }

            this.lastRuleValues.allEnumMultiselect = dropDownValue;
        }
        else if (changeType == 'List') {
            rule.valueLists = dropDownValue;
        }
    }
    //#endregion

    //#region Address Lat/Long
    onRemoveAddressLocation(event: any) {

    }

    onAddressChanged(event: any, selectedValue: any) {
        if (event) {
            let addressLatLng: SavedSearchNS.AddressLatLong = {
                address: event.formatted_address,
                latitude: event.geometry.location.lat(),
                longitude: event.geometry.location.lng(),
                radius: this.selectedLatLng?.radius ?? null,
            }
            this.selectedLatLng = addressLatLng;
        }
    }

    onAddressBlur(event: any) {

    }

    openAddressSelect(type: 'Add' | 'List' | 'Edit') {
        this.selectedLatLngType = type;
        if (type == 'Add') {
            this.selectedLatLng = this.lastRuleValues.selectedValue ?? { address: null, latitude: null, longitude: null, radius: null };
        }
        else if (type == 'List') {

        }
        else if (type == 'Edit') {
            this.selectedLatLng = this.lastRuleValues.selectedValue ?? { address: null, latitude: null, longitude: null, radius: null }
        }
        this.displayAddressSelect = true;
    }

    saveAddressSelect() {
        this.displayAddressSelect = false;
        if (this.selectedLatLng) {
            if (this.selectedLatLngType == 'Add' || this.selectedLatLngType == 'Edit') {
                this.lastRuleValues.selectedValue = this.selectedLatLng;
            }
            else if (this.selectedLatLngType == 'List') {

            }
        }
    }

    //#endregion
    getBillStatus(changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList) {
        this.setDropDownValue(changeType, BillStatus, rule);
    }

    getBillPaymentStatus(changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList) {
        this.setDropDownValue(changeType, BillPaymentStatus, rule);
    }

    getPurchaseOrderIsActive(changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList) {
        this.setDropDownValue(changeType, PurchaseOrderIsActive, rule);
    }

    getVendorBillStatus(changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList) {
        this.setDropDownValue(changeType, VendorAllBillStatus, rule);
    }

    getPurchaseOrderStatus(changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList) {
        this.setDropDownValue(changeType, PurchaseOrderStatus, rule);
    }


    getVendorRMAStatus(changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList) {
        this.setDropDownValue(changeType, VendorRMAStatus, rule);
    }

    getVendorCreditStatus(changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList) {
        this.setDropDownValue(changeType, VendorCreditStatus, rule);
    }


    getVendorTransactionStage(changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList) {
        this.setDropDownValue(changeType, VendorTransactionStage, rule);
    }

    getVendorBillPaymentStatus(changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList) {
        this.setDropDownValue(changeType, VendorBillPaymentStatus, rule);
    }

    getVendorPaymentReceiptsPaymentStatus(changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList) {
        this.setDropDownValue(changeType, VendorPaymentReceiptsStatus, rule);
    }

    getAgingStatus(changeType: 'Selected' | 'List', rule: SavedSearchNS.IRuleList) {
        this.setDropDownValue(changeType, AgingStatus, rule);
    }


    showDefaultParentRule() {
        if([EstimateOrderModuleId,OpportunityModuleId,InvoiceOrderModuleId, SOModuleId].includes((this.selectedParentModule.objectId)) && !this.selectedAccountChannel) return;

        if ( [LeadModuleId, AccountModuleId].includes((this.selectedParentModule.objectId))) {
            const sectionName = this.filterDDFlat.find((item)=>item.field=='businessName')
            const operator=sectionName.operatorsDD.find((value)=>value.name=='HasValue')
            this.commonObjectForRuleModule(sectionName,operator)
        }
        else if (this.selectedParentModule.objectId === OpportunityModuleId ) {
            const sectionName = this.filterDDFlat.find((item)=>item.field=='name')
            const operator=sectionName.operatorsDD.find((value)=>value.name=='HasValue')
            this.commonObjectForRuleModule(sectionName,operator)
        }
        else if (this.selectedParentModule.objectId === TaskModuleId ) {
            const sectionName = this.filterDDFlat.find((item)=>item.field=='taskId')
            const operator=sectionName.operatorsDD.find((value)=>value.name=='HasValue')
            this.commonObjectForRuleModule(sectionName,operator)
        }
        else if (this.selectedParentModule.objectId === VendorModuleId ) {
            const sectionName = this.filterDDFlat.find((item)=>item.field=='vendorName')
            const operator=sectionName.operatorsDD.find((value)=>value.name=='HasValue')
            this.commonObjectForRuleModule(sectionName,operator)
        }
        else if ([EstimateOrderModuleId, InvoiceOrderModuleId, SOModuleId].includes((this.selectedParentModule.objectId)) ) {
            const sectionName = this.filterDDFlat.find((item)=>item.field=='number')
            const operator=sectionName?.operatorsDD.find((value)=>value.name=='HasValue')
            this.commonObjectForRuleModule(sectionName,operator)
        }

        else if (this.selectedParentModule.objectId === ProductModuleId ) {
            const sectionName = this.filterDDFlat.find((item)=>item.field=='itemNo')
            const operator=sectionName.operatorsDD.find((value)=>value.name=='HasValue')
            this.commonObjectForRuleModule(sectionName,operator)
        }
        else if (this.selectedParentModule.objectId === ActivityModuleId ) {
            const sectionName = this.filterDDFlat.find((item)=>item.field=='logType')
            const operator=sectionName.operatorsDD.find((value)=>value.name=='HasValue')
            this.commonObjectForRuleModule(sectionName,operator)
        }
    }

    commonObjectForRuleModule(sectionName:any,operator:any){
       const obj: any = {
            id: 0,
            filter: sectionName,
            filtersDD: this.lastRuleValues.filtersDD,
            operator: operator,
            template: this.selectedParentTemplate,
            module: this.selectedParentModule,
            value: 'Any',
            objectId: this.selectedParentModule?.objectId,
            isMainModule: true,
            dataTypeWithOperator: {
                DataType: "String",
                Operator: "HasValue",
                NoOfValuesToBePassed: "No_Value"
            },
            value2: null,
            choice: null,
            objectName: this.selectedParentModule.name,
            canEdit: true,
            accountChannel: this.selectedAccountChannel,
            compareWithField: false,
            comparisonCriteria: null,
            comparisonCriteriaLabel: null,
            comparisonCriteriaParentLabel: null,
            isCustomComparisonCriteria: false,
            comparisonCriteriaObject: this.selectedParentModule.name,
            customAttributeObjectId: null,
            comparisonCustomAttributeObjectId: null,

        }
        this.ruleData.push(obj)
    }


}
